/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/webpack/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 362);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Vue.js v2.0.3
 * (c) 2014-2016 Evan You
 * Released under the MIT License.
 */
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.Vue=t()}(this,function(){"use strict";function e(e){return null==e?"":"object"==typeof e?JSON.stringify(e,null,2):String(e)}function t(e){var t=parseFloat(e,10);return t||0===t?t:e}function n(e,t){for(var n=Object.create(null),r=e.split(","),i=0;i<r.length;i++)n[r[i]]=!0;return t?function(e){return n[e.toLowerCase()]}:function(e){return n[e]}}function r(e,t){if(e.length){var n=e.indexOf(t);if(n>-1)return e.splice(n,1)}}function i(e,t){return _r.call(e,t)}function a(e){return"string"==typeof e||"number"==typeof e}function o(e){var t=Object.create(null);return function(n){var r=t[n];return r||(t[n]=e(n))}}function s(e,t){function n(n){var r=arguments.length;return r?r>1?e.apply(t,arguments):e.call(t,n):e.call(t)}return n._length=e.length,n}function c(e,t){t=t||0;for(var n=e.length-t,r=new Array(n);n--;)r[n]=e[n+t];return r}function u(e,t){for(var n in t)e[n]=t[n];return e}function l(e){return null!==e&&"object"==typeof e}function f(e){return kr.call(e)===Ar}function d(e){for(var t={},n=0;n<e.length;n++)e[n]&&u(t,e[n]);return t}function p(){}function v(e){return e.reduce(function(e,t){return e.concat(t.staticKeys||[])},[]).join(",")}function h(e,t){return e==t||!(!l(e)||!l(t))&&JSON.stringify(e)===JSON.stringify(t)}function m(e,t){for(var n=0;n<e.length;n++)if(h(e[n],t))return n;return-1}function g(e){var t=(e+"").charCodeAt(0);return 36===t||95===t}function y(e,t,n,r){Object.defineProperty(e,t,{value:n,enumerable:!!r,writable:!0,configurable:!0})}function _(e){if(!Sr.test(e)){var t=e.split(".");return function(e){for(var n=0;n<t.length;n++){if(!e)return;e=e[t[n]]}return e}}}function b(e){return/native code/.test(e.toString())}function $(e){Hr.target&&Ur.push(Hr.target),Hr.target=e}function w(){Hr.target=Ur.pop()}function C(){zr.length=0,Vr={},Jr=qr=!1}function x(){for(qr=!0,zr.sort(function(e,t){return e.id-t.id}),Kr=0;Kr<zr.length;Kr++){var e=zr[Kr],t=e.id;Vr[t]=null,e.run()}Ir&&Tr.devtools&&Ir.emit("flush"),C()}function k(e){var t=e.id;if(null==Vr[t]){if(Vr[t]=!0,qr){for(var n=zr.length-1;n>=0&&zr[n].id>e.id;)n--;zr.splice(Math.max(n,Kr)+1,0,e)}else zr.push(e);Jr||(Jr=!0,Br(x))}}function A(e,t){var n,r;t||(t=Gr,t.clear());var i=Array.isArray(e),a=l(e);if((i||a)&&Object.isExtensible(e)){if(e.__ob__){var o=e.__ob__.dep.id;if(t.has(o))return;t.add(o)}if(i)for(n=e.length;n--;)A(e[n],t);else if(a)for(r=Object.keys(e),n=r.length;n--;)A(e[r[n]],t)}}function O(e,t){e.__proto__=t}function T(e,t,n){for(var r=0,i=n.length;r<i;r++){var a=n[r];y(e,a,t[a])}}function S(e){if(l(e)){var t;return i(e,"__ob__")&&e.__ob__ instanceof ti?t=e.__ob__:ei.shouldConvert&&!Tr._isServer&&(Array.isArray(e)||f(e))&&Object.isExtensible(e)&&!e._isVue&&(t=new ti(e)),t}}function E(e,t,n,r){var i=new Hr,a=Object.getOwnPropertyDescriptor(e,t);if(!a||a.configurable!==!1){var o=a&&a.get,s=a&&a.set,c=S(n);Object.defineProperty(e,t,{enumerable:!0,configurable:!0,get:function(){var t=o?o.call(e):n;return Hr.target&&(i.depend(),c&&c.dep.depend(),Array.isArray(t)&&N(t)),t},set:function(t){var r=o?o.call(e):n;t!==r&&(s?s.call(e,t):n=t,c=S(t),i.notify())}})}}function j(e,t,n){if(Array.isArray(e))return e.splice(t,1,n),n;if(i(e,t))return void(e[t]=n);var r=e.__ob__;if(!(e._isVue||r&&r.vmCount))return r?(E(r.value,t,n),r.dep.notify(),n):void(e[t]=n)}function L(e,t){var n=e.__ob__;e._isVue||n&&n.vmCount||i(e,t)&&(delete e[t],n&&n.dep.notify())}function N(e){for(var t=void 0,n=0,r=e.length;n<r;n++)t=e[n],t&&t.__ob__&&t.__ob__.dep.depend(),Array.isArray(t)&&N(t)}function D(e){e._watchers=[],M(e),P(e),R(e),B(e),F(e)}function M(e){var t=e.$options.props;if(t){var n=e.$options.propsData||{},r=e.$options._propKeys=Object.keys(t),i=!e.$parent;ei.shouldConvert=i;for(var a=function(i){var a=r[i];E(e,a,Le(a,t,n,e))},o=0;o<r.length;o++)a(o);ei.shouldConvert=!0}}function P(e){var t=e.$options.data;t=e._data="function"==typeof t?t.call(e):t||{},f(t)||(t={});for(var n=Object.keys(t),r=e.$options.props,a=n.length;a--;)r&&i(r,n[a])||z(e,n[a]);S(t),t.__ob__&&t.__ob__.vmCount++}function R(e){var t=e.$options.computed;if(t)for(var n in t){var r=t[n];"function"==typeof r?(ni.get=I(r,e),ni.set=p):(ni.get=r.get?r.cache!==!1?I(r.get,e):s(r.get,e):p,ni.set=r.set?s(r.set,e):p),Object.defineProperty(e,n,ni)}}function I(e,t){var n=new Zr(t,e,p,{lazy:!0});return function(){return n.dirty&&n.evaluate(),Hr.target&&n.depend(),n.value}}function B(e){var t=e.$options.methods;if(t)for(var n in t)e[n]=null==t[n]?p:s(t[n],e)}function F(e){var t=e.$options.watch;if(t)for(var n in t){var r=t[n];if(Array.isArray(r))for(var i=0;i<r.length;i++)H(e,n,r[i]);else H(e,n,r)}}function H(e,t,n){var r;f(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=e[n]),e.$watch(t,n,r)}function U(e){var t={};t.get=function(){return this._data},Object.defineProperty(e.prototype,"$data",t),e.prototype.$set=j,e.prototype.$delete=L,e.prototype.$watch=function(e,t,n){var r=this;n=n||{},n.user=!0;var i=new Zr(r,e,t,n);return n.immediate&&t.call(r,i.value),function(){i.teardown()}}}function z(e,t){g(t)||Object.defineProperty(e,t,{configurable:!0,enumerable:!0,get:function(){return e._data[t]},set:function(n){e._data[t]=n}})}function V(e){var t=new ri(e.tag,e.data,e.children,e.text,e.elm,e.ns,e.context,e.componentOptions);return t.isStatic=e.isStatic,t.key=e.key,t.isCloned=!0,t}function J(e){for(var t=new Array(e.length),n=0;n<e.length;n++)t[n]=V(e[n]);return t}function q(e,t,n,r){r+=t;var i=e.__injected||(e.__injected={});if(!i[r]){i[r]=!0;var a=e[t];a?e[t]=function(){a.apply(this,arguments),n.apply(this,arguments)}:e[t]=n}}function K(e,t,n,r,i){var a,o,s,c,u,l;for(a in e)if(o=e[a],s=t[a],o)if(s){if(o!==s)if(Array.isArray(s)){s.length=o.length;for(var f=0;f<s.length;f++)s[f]=o[f];e[a]=s}else s.fn=o,e[a]=s}else l="!"===a.charAt(0),u=l?a.slice(1):a,Array.isArray(o)?n(u,o.invoker=W(o),l):(o.invoker||(c=o,o=e[a]={},o.fn=c,o.invoker=Z(o)),n(u,o.invoker,l));else;for(a in t)e[a]||(u="!"===a.charAt(0)?a.slice(1):a,r(u,t[a].invoker))}function W(e){return function(t){for(var n=arguments,r=1===arguments.length,i=0;i<e.length;i++)r?e[i](t):e[i].apply(null,n)}}function Z(e){return function(t){var n=1===arguments.length;n?e.fn(t):e.fn.apply(null,arguments)}}function G(e,t,n){if(a(e))return[Y(e)];if(Array.isArray(e)){for(var r=[],i=0,o=e.length;i<o;i++){var s=e[i],c=r[r.length-1];Array.isArray(s)?r.push.apply(r,G(s,t,(n||"")+"_"+i)):a(s)?c&&c.text?c.text+=String(s):""!==s&&r.push(Y(s)):s instanceof ri&&(s.text&&c&&c.text?c.text+=s.text:(t&&Q(s,t),s.tag&&null==s.key&&null!=n&&(s.key="__vlist"+n+"_"+i+"__"),r.push(s)))}return r}}function Y(e){return new ri(void 0,void 0,void 0,String(e))}function Q(e,t){if(e.tag&&!e.ns&&(e.ns=t,e.children))for(var n=0,r=e.children.length;n<r;n++)Q(e.children[n],t)}function X(e){return e&&e.filter(function(e){return e&&e.componentOptions})[0]}function ee(e){var t=e.$options,n=t.parent;if(n&&!t.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(e)}e.$parent=n,e.$root=n?n.$root:e,e.$children=[],e.$refs={},e._watcher=null,e._inactive=!1,e._isMounted=!1,e._isDestroyed=!1,e._isBeingDestroyed=!1}function te(e){e.prototype._mount=function(e,t){var n=this;return n.$el=e,n.$options.render||(n.$options.render=ii),ne(n,"beforeMount"),n._watcher=new Zr(n,function(){n._update(n._render(),t)},p),t=!1,null==n.$vnode&&(n._isMounted=!0,ne(n,"mounted")),n},e.prototype._update=function(e,t){var n=this;n._isMounted&&ne(n,"beforeUpdate");var r=n.$el,i=ai;ai=n;var a=n._vnode;n._vnode=e,a?n.$el=n.__patch__(a,e):n.$el=n.__patch__(n.$el,e,t),ai=i,r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el),n._isMounted&&ne(n,"updated")},e.prototype._updateFromParent=function(e,t,n,r){var i=this,a=!(!i.$options._renderChildren&&!r);if(i.$options._parentVnode=n,i.$options._renderChildren=r,e&&i.$options.props){ei.shouldConvert=!1;for(var o=i.$options._propKeys||[],s=0;s<o.length;s++){var c=o[s];i[c]=Le(c,i.$options.props,e,i)}ei.shouldConvert=!0}if(t){var u=i.$options._parentListeners;i.$options._parentListeners=t,i._updateListeners(t,u)}a&&(i.$slots=_e(r,i._renderContext),i.$forceUpdate())},e.prototype.$forceUpdate=function(){var e=this;e._watcher&&e._watcher.update()},e.prototype.$destroy=function(){var e=this;if(!e._isBeingDestroyed){ne(e,"beforeDestroy"),e._isBeingDestroyed=!0;var t=e.$parent;!t||t._isBeingDestroyed||e.$options.abstract||r(t.$children,e),e._watcher&&e._watcher.teardown();for(var n=e._watchers.length;n--;)e._watchers[n].teardown();e._data.__ob__&&e._data.__ob__.vmCount--,e._isDestroyed=!0,ne(e,"destroyed"),e.$off(),e.$el&&(e.$el.__vue__=null),e.__patch__(e._vnode,null)}}}function ne(e,t){var n=e.$options[t];if(n)for(var r=0,i=n.length;r<i;r++)n[r].call(e);e.$emit("hook:"+t)}function re(e,t,n,r,i){if(e&&(l(e)&&(e=Ce.extend(e)),"function"==typeof e)){if(!e.cid)if(e.resolved)e=e.resolved;else if(e=le(e,function(){n.$forceUpdate()}),!e)return;t=t||{};var a=fe(t,e);if(e.options.functional)return ie(e,a,t,n,r);var o=t.on;t.on=t.nativeOn,e.options.abstract&&(t={}),pe(t);var s=e.options.name||i,c=new ri("vue-component-"+e.cid+(s?"-"+s:""),t,void 0,void 0,void 0,void 0,n,{Ctor:e,propsData:a,listeners:o,tag:i,children:r});return c}}function ie(e,t,n,r,i){var a={},o=e.options.props;if(o)for(var c in o)a[c]=Le(c,o,t);var u=e.options.render.call(null,s(he,{_self:Object.create(r)}),{props:a,data:n,parent:r,children:G(i),slots:function(){return _e(i,r)}});return u instanceof ri&&(u.functionalContext=r,n.slot&&((u.data||(u.data={})).slot=n.slot)),u}function ae(e,t){var n=e.componentOptions,r={_isComponent:!0,parent:t,propsData:n.propsData,_componentTag:n.tag,_parentVnode:e,_parentListeners:n.listeners,_renderChildren:n.children},i=e.data.inlineTemplate;return i&&(r.render=i.render,r.staticRenderFns=i.staticRenderFns),new n.Ctor(r)}function oe(e,t){if(!e.child||e.child._isDestroyed){var n=e.child=ae(e,ai);n.$mount(t?e.elm:void 0,t)}}function se(e,t){var n=t.componentOptions,r=t.child=e.child;r._updateFromParent(n.propsData,n.listeners,t,n.children)}function ce(e){e.child._isMounted||(e.child._isMounted=!0,ne(e.child,"mounted")),e.data.keepAlive&&(e.child._inactive=!1,ne(e.child,"activated"))}function ue(e){e.child._isDestroyed||(e.data.keepAlive?(e.child._inactive=!0,ne(e.child,"deactivated")):e.child.$destroy())}function le(e,t){if(!e.requested){e.requested=!0;var n=e.pendingCallbacks=[t],r=!0,i=function(t){if(l(t)&&(t=Ce.extend(t)),e.resolved=t,!r)for(var i=0,a=n.length;i<a;i++)n[i](t)},a=function(e){},o=e(i,a);return o&&"function"==typeof o.then&&!e.resolved&&o.then(i,a),r=!1,e.resolved}e.pendingCallbacks.push(t)}function fe(e,t){var n=t.options.props;if(n){var r={},i=e.attrs,a=e.props,o=e.domProps;if(i||a||o)for(var s in n){var c=xr(s);de(r,a,s,c,!0)||de(r,i,s,c)||de(r,o,s,c)}return r}}function de(e,t,n,r,a){if(t){if(i(t,n))return e[n]=t[n],a||delete t[n],!0;if(i(t,r))return e[n]=t[r],a||delete t[r],!0}return!1}function pe(e){e.hook||(e.hook={});for(var t=0;t<si.length;t++){var n=si[t],r=e.hook[n],i=oi[n];e.hook[n]=r?ve(i,r):i}}function ve(e,t){return function(n,r){e(n,r),t(n,r)}}function he(e,t,n){return t&&(Array.isArray(t)||"object"!=typeof t)&&(n=t,t=void 0),me(this._self,e,t,n)}function me(e,t,n,r){if(!n||!n.__ob__){if(!t)return ii();if("string"==typeof t){var i,a=Tr.getTagNamespace(t);return Tr.isReservedTag(t)?new ri(t,n,G(r,a),void 0,void 0,a,e):(i=je(e.$options,"components",t))?re(i,n,e,r,t):new ri(t,n,G(r,a),void 0,void 0,a,e)}return re(t,n,e,r)}}function ge(e){e.$vnode=null,e._vnode=null,e._staticTrees=null,e._renderContext=e.$options._parentVnode&&e.$options._parentVnode.context,e.$slots=_e(e.$options._renderChildren,e._renderContext),e.$createElement=s(he,e),e.$options.el&&e.$mount(e.$options.el)}function ye(n){n.prototype.$nextTick=function(e){Br(e,this)},n.prototype._render=function(){var e=this,t=e.$options,n=t.render,r=t.staticRenderFns,i=t._parentVnode;if(e._isMounted)for(var a in e.$slots)e.$slots[a]=J(e.$slots[a]);r&&!e._staticTrees&&(e._staticTrees=[]),e.$vnode=i;var o;try{o=n.call(e._renderProxy,e.$createElement)}catch(t){if(Tr.errorHandler)Tr.errorHandler.call(null,t,e);else{if(Tr._isServer)throw t;setTimeout(function(){throw t},0)}o=e._vnode}return o instanceof ri||(o=ii()),o.parent=i,o},n.prototype._h=he,n.prototype._s=e,n.prototype._n=t,n.prototype._e=ii,n.prototype._q=h,n.prototype._i=m,n.prototype._m=function(e,t){var n=this._staticTrees[e];if(n&&!t)return Array.isArray(n)?J(n):V(n);if(n=this._staticTrees[e]=this.$options.staticRenderFns[e].call(this._renderProxy),Array.isArray(n))for(var r=0;r<n.length;r++)"string"!=typeof n[r]&&(n[r].isStatic=!0,n[r].key="__static__"+e+"_"+r);else n.isStatic=!0,n.key="__static__"+e;return n};var r=function(e){return e};n.prototype._f=function(e){return je(this.$options,"filters",e,!0)||r},n.prototype._l=function(e,t){var n,r,i,a,o;if(Array.isArray(e))for(n=new Array(e.length),r=0,i=e.length;r<i;r++)n[r]=t(e[r],r);else if("number"==typeof e)for(n=new Array(e),r=0;r<e;r++)n[r]=t(r+1,r);else if(l(e))for(a=Object.keys(e),n=new Array(a.length),r=0,i=a.length;r<i;r++)o=a[r],n[r]=t(e[o],o,r);return n},n.prototype._t=function(e,t){var n=this.$slots[e];return n||t},n.prototype._b=function(e,t,n){if(t)if(l(t)){Array.isArray(t)&&(t=d(t));for(var r in t)if("class"===r||"style"===r)e[r]=t[r];else{var i=n||Tr.mustUseProp(r)?e.domProps||(e.domProps={}):e.attrs||(e.attrs={});i[r]=t[r]}}else;return e},n.prototype._k=function(e){return Tr.keyCodes[e]}}function _e(e,t){var n={};if(!e)return n;for(var r,i,a=G(e)||[],o=[],s=0,c=a.length;s<c;s++)if(i=a[s],(i.context===t||i.functionalContext===t)&&i.data&&(r=i.data.slot)){var u=n[r]||(n[r]=[]);"template"===i.tag?u.push.apply(u,i.children):u.push(i)}else o.push(i);return o.length&&(1!==o.length||" "!==o[0].text&&!o[0].isComment)&&(n.default=o),n}function be(e){e._events=Object.create(null);var t=e.$options._parentListeners,n=s(e.$on,e),r=s(e.$off,e);e._updateListeners=function(t,i){K(t,i||{},n,r,e)},t&&e._updateListeners(t)}function $e(e){e.prototype.$on=function(e,t){var n=this;return(n._events[e]||(n._events[e]=[])).push(t),n},e.prototype.$once=function(e,t){function n(){r.$off(e,n),t.apply(r,arguments)}var r=this;return n.fn=t,r.$on(e,n),r},e.prototype.$off=function(e,t){var n=this;if(!arguments.length)return n._events=Object.create(null),n;var r=n._events[e];if(!r)return n;if(1===arguments.length)return n._events[e]=null,n;for(var i,a=r.length;a--;)if(i=r[a],i===t||i.fn===t){r.splice(a,1);break}return n},e.prototype.$emit=function(e){var t=this,n=t._events[e];if(n){n=n.length>1?c(n):n;for(var r=c(arguments,1),i=0,a=n.length;i<a;i++)n[i].apply(t,r)}return t}}function we(e){function t(e,t){var r=e.$options=Object.create(n(e));r.parent=t.parent,r.propsData=t.propsData,r._parentVnode=t._parentVnode,r._parentListeners=t._parentListeners,r._renderChildren=t._renderChildren,r._componentTag=t._componentTag,t.render&&(r.render=t.render,r.staticRenderFns=t.staticRenderFns)}function n(e){var t=e.constructor,n=t.options;if(t.super){var r=t.super.options,i=t.superOptions;r!==i&&(t.superOptions=r,n=t.options=Ee(r,t.extendOptions),n.name&&(n.components[n.name]=t))}return n}e.prototype._init=function(e){var r=this;r._uid=ci++,r._isVue=!0,e&&e._isComponent?t(r,e):r.$options=Ee(n(r),e||{},r),r._renderProxy=r,r._self=r,ee(r),be(r),ne(r,"beforeCreate"),D(r),ne(r,"created"),ge(r)}}function Ce(e){this._init(e)}function xe(e,t){var n,r,a;for(n in t)r=e[n],a=t[n],i(e,n)?l(r)&&l(a)&&xe(r,a):j(e,n,a);return e}function ke(e,t){return t?e?e.concat(t):Array.isArray(t)?t:[t]:e}function Ae(e,t){var n=Object.create(e||null);return t?u(n,t):n}function Oe(e){if(e.components){var t,n=e.components;for(var r in n){var i=r.toLowerCase();yr(i)||Tr.isReservedTag(i)||(t=n[r],f(t)&&(n[r]=Ce.extend(t)))}}}function Te(e){var t=e.props;if(t){var n,r,i,a={};if(Array.isArray(t))for(n=t.length;n--;)r=t[n],"string"==typeof r&&(i=$r(r),a[i]={type:null});else if(f(t))for(var o in t)r=t[o],i=$r(o),a[i]=f(r)?r:{type:r};e.props=a}}function Se(e){var t=e.directives;if(t)for(var n in t){var r=t[n];"function"==typeof r&&(t[n]={bind:r,update:r})}}function Ee(e,t,n){function r(r){var i=fi[r]||di;l[r]=i(e[r],t[r],n,r)}Oe(t),Te(t),Se(t);var a=t.extends;if(a&&(e="function"==typeof a?Ee(e,a.options,n):Ee(e,a,n)),t.mixins)for(var o=0,s=t.mixins.length;o<s;o++){var c=t.mixins[o];c.prototype instanceof Ce&&(c=c.options),e=Ee(e,c,n)}var u,l={};for(u in e)r(u);for(u in t)i(e,u)||r(u);return l}function je(e,t,n,r){if("string"==typeof n){var i=e[t],a=i[n]||i[$r(n)]||i[wr($r(n))];return a}}function Le(e,t,n,r){var a=t[e],o=!i(n,e),s=n[e];if(Me(a.type)&&(o&&!i(a,"default")?s=!1:""!==s&&s!==xr(e)||(s=!0)),void 0===s){s=Ne(r,a,e);var c=ei.shouldConvert;ei.shouldConvert=!0,S(s),ei.shouldConvert=c}return s}function Ne(e,t,n){if(i(t,"default")){var r=t.default;return l(r),"function"==typeof r&&t.type!==Function?r.call(e):r}}function De(e){var t=e&&e.toString().match(/^\s*function (\w+)/);return t&&t[1]}function Me(e){if(!Array.isArray(e))return"Boolean"===De(e);for(var t=0,n=e.length;t<n;t++)if("Boolean"===De(e[t]))return!0;return!1}function Pe(e){e.use=function(e){if(!e.installed){var t=c(arguments,1);return t.unshift(this),"function"==typeof e.install?e.install.apply(e,t):e.apply(null,t),e.installed=!0,this}}}function Re(e){e.mixin=function(t){e.options=Ee(e.options,t)}}function Ie(e){e.cid=0;var t=1;e.extend=function(e){e=e||{};var n=this,r=0===n.cid;if(r&&e._Ctor)return e._Ctor;var i=e.name||n.options.name,a=function(e){this._init(e)};return a.prototype=Object.create(n.prototype),a.prototype.constructor=a,a.cid=t++,a.options=Ee(n.options,e),a.super=n,a.extend=n.extend,Tr._assetTypes.forEach(function(e){a[e]=n[e]}),i&&(a.options.components[i]=a),a.superOptions=n.options,a.extendOptions=e,r&&(e._Ctor=a),a}}function Be(e){Tr._assetTypes.forEach(function(t){e[t]=function(n,r){return r?("component"===t&&f(r)&&(r.name=r.name||n,r=e.extend(r)),"directive"===t&&"function"==typeof r&&(r={bind:r,update:r}),this.options[t+"s"][n]=r,r):this.options[t+"s"][n]}})}function Fe(e){var t={};t.get=function(){return Tr},Object.defineProperty(e,"config",t),e.util=pi,e.set=j,e.delete=L,e.nextTick=Br,e.options=Object.create(null),Tr._assetTypes.forEach(function(t){e.options[t+"s"]=Object.create(null)}),u(e.options.components,hi),Pe(e),Re(e),Ie(e),Be(e)}function He(e){for(var t=e.data,n=e,r=e;r.child;)r=r.child._vnode,r.data&&(t=Ue(r.data,t));for(;n=n.parent;)n.data&&(t=Ue(t,n.data));return ze(t)}function Ue(e,t){return{staticClass:Ve(e.staticClass,t.staticClass),class:e.class?[e.class,t.class]:t.class}}function ze(e){var t=e.class,n=e.staticClass;return n||t?Ve(n,Je(t)):""}function Ve(e,t){return e?t?e+" "+t:e:t||""}function Je(e){var t="";if(!e)return t;if("string"==typeof e)return e;if(Array.isArray(e)){for(var n,r=0,i=e.length;r<i;r++)e[r]&&(n=Je(e[r]))&&(t+=n+" ");return t.slice(0,-1)}if(l(e)){for(var a in e)e[a]&&(t+=a+" ");return t.slice(0,-1)}return t}function qe(e){return Si(e)?"svg":"math"===e?"math":void 0}function Ke(e){if(!jr)return!0;if(ji(e))return!1;if(e=e.toLowerCase(),null!=Li[e])return Li[e];var t=document.createElement(e);return e.indexOf("-")>-1?Li[e]=t.constructor===window.HTMLUnknownElement||t.constructor===window.HTMLElement:Li[e]=/HTMLUnknownElement/.test(t.toString())}function We(e){if("string"==typeof e){if(e=document.querySelector(e),!e)return document.createElement("div")}return e}function Ze(e,t){var n=document.createElement(e);return"select"!==e?n:(t.data&&t.data.attrs&&"multiple"in t.data.attrs&&n.setAttribute("multiple","multiple"),n)}function Ge(e,t){return document.createElementNS(xi[e],t)}function Ye(e){return document.createTextNode(e)}function Qe(e){return document.createComment(e)}function Xe(e,t,n){e.insertBefore(t,n)}function et(e,t){e.removeChild(t)}function tt(e,t){e.appendChild(t)}function nt(e){return e.parentNode}function rt(e){return e.nextSibling}function it(e){return e.tagName}function at(e,t){e.textContent=t}function ot(e){return e.childNodes}function st(e,t,n){e.setAttribute(t,n)}function ct(e,t){var n=e.data.ref;if(n){var i=e.context,a=e.child||e.elm,o=i.$refs;t?Array.isArray(o[n])?r(o[n],a):o[n]===a&&(o[n]=void 0):e.data.refInFor?Array.isArray(o[n])?o[n].push(a):o[n]=[a]:o[n]=a}}function ut(e){return null==e}function lt(e){return null!=e}function ft(e,t){return e.key===t.key&&e.tag===t.tag&&e.isComment===t.isComment&&!e.data==!t.data}function dt(e,t,n){var r,i,a={};for(r=t;r<=n;++r)i=e[r].key,lt(i)&&(a[i]=r);return a}function pt(e){function t(e){return new ri(C.tagName(e).toLowerCase(),{},[],void 0,e)}function n(e,t){function n(){0===--n.listeners&&r(e)}return n.listeners=t,n}function r(e){var t=C.parentNode(e);C.removeChild(t,e)}function i(e,t,n){var r,i=e.data;if(e.isRootInsert=!n,lt(i)&&(lt(r=i.hook)&&lt(r=r.init)&&r(e),lt(r=e.child)))return u(e,t),e.elm;var a=e.children,s=e.tag;return lt(s)?(e.elm=e.ns?C.createElementNS(e.ns,s):C.createElement(s,e),l(e),o(e,a,t),lt(i)&&c(e,t)):e.isComment?e.elm=C.createComment(e.text):e.elm=C.createTextNode(e.text),e.elm}function o(e,t,n){if(Array.isArray(t))for(var r=0;r<t.length;++r)C.appendChild(e.elm,i(t[r],n,!0));else a(e.text)&&C.appendChild(e.elm,C.createTextNode(e.text))}function s(e){for(;e.child;)e=e.child._vnode;return lt(e.tag)}function c(e,t){for(var n=0;n<$.create.length;++n)$.create[n](Mi,e);_=e.data.hook,lt(_)&&(_.create&&_.create(Mi,e),_.insert&&t.push(e))}function u(e,t){e.data.pendingInsert&&t.push.apply(t,e.data.pendingInsert),e.elm=e.child.$el,s(e)?(c(e,t),l(e)):(ct(e),t.push(e))}function l(e){var t;lt(t=e.context)&&lt(t=t.$options._scopeId)&&C.setAttribute(e.elm,t,""),lt(t=ai)&&t!==e.context&&lt(t=t.$options._scopeId)&&C.setAttribute(e.elm,t,"")}function f(e,t,n,r,a,o){for(;r<=a;++r)C.insertBefore(e,i(n[r],o),t)}function d(e){var t,n,r=e.data;if(lt(r))for(lt(t=r.hook)&&lt(t=t.destroy)&&t(e),t=0;t<$.destroy.length;++t)$.destroy[t](e);if(lt(t=e.children))for(n=0;n<e.children.length;++n)d(e.children[n])}function p(e,t,n,r){for(;n<=r;++n){var i=t[n];lt(i)&&(lt(i.tag)?(v(i),d(i)):C.removeChild(e,i.elm))}}function v(e,t){if(t||lt(e.data)){var i=$.remove.length+1;for(t?t.listeners+=i:t=n(e.elm,i),lt(_=e.child)&&lt(_=_._vnode)&&lt(_.data)&&v(_,t),_=0;_<$.remove.length;++_)$.remove[_](e,t);lt(_=e.data.hook)&&lt(_=_.remove)?_(e,t):t()}else r(e.elm)}function h(e,t,n,r,a){for(var o,s,c,u,l=0,d=0,v=t.length-1,h=t[0],g=t[v],y=n.length-1,_=n[0],b=n[y],$=!a;l<=v&&d<=y;)ut(h)?h=t[++l]:ut(g)?g=t[--v]:ft(h,_)?(m(h,_,r),h=t[++l],_=n[++d]):ft(g,b)?(m(g,b,r),g=t[--v],b=n[--y]):ft(h,b)?(m(h,b,r),$&&C.insertBefore(e,h.elm,C.nextSibling(g.elm)),h=t[++l],b=n[--y]):ft(g,_)?(m(g,_,r),$&&C.insertBefore(e,g.elm,h.elm),g=t[--v],_=n[++d]):(ut(o)&&(o=dt(t,l,v)),s=lt(_.key)?o[_.key]:null,ut(s)?(C.insertBefore(e,i(_,r),h.elm),_=n[++d]):(c=t[s],c.tag!==_.tag?(C.insertBefore(e,i(_,r),h.elm),_=n[++d]):(m(c,_,r),t[s]=void 0,$&&C.insertBefore(e,_.elm,h.elm),_=n[++d])));l>v?(u=ut(n[y+1])?null:n[y+1].elm,f(e,u,n,d,y,r)):d>y&&p(e,t,l,v)}function m(e,t,n,r){if(e!==t){if(t.isStatic&&e.isStatic&&t.key===e.key&&t.isCloned)return void(t.elm=e.elm);var i,a=t.data,o=lt(a);o&&lt(i=a.hook)&&lt(i=i.prepatch)&&i(e,t);var c=t.elm=e.elm,u=e.children,l=t.children;if(o&&s(t)){for(i=0;i<$.update.length;++i)$.update[i](e,t);lt(i=a.hook)&&lt(i=i.update)&&i(e,t)}ut(t.text)?lt(u)&&lt(l)?u!==l&&h(c,u,l,n,r):lt(l)?(lt(e.text)&&C.setTextContent(c,""),f(c,null,l,0,l.length-1,n)):lt(u)?p(c,u,0,u.length-1):lt(e.text)&&C.setTextContent(c,""):e.text!==t.text&&C.setTextContent(c,t.text),o&&lt(i=a.hook)&&lt(i=i.postpatch)&&i(e,t)}}function g(e,t,n){if(n&&e.parent)e.parent.data.pendingInsert=t;else for(var r=0;r<t.length;++r)t[r].data.hook.insert(t[r])}function y(e,t,n){t.elm=e;var r=t.tag,i=t.data,a=t.children;if(lt(i)&&(lt(_=i.hook)&&lt(_=_.init)&&_(t,!0),lt(_=t.child)))return u(t,n),!0;if(lt(r)){if(lt(a)){var s=C.childNodes(e);if(s.length){var l=!0;if(s.length!==a.length)l=!1;else for(var f=0;f<a.length;f++)if(!y(s[f],a[f],n)){l=!1;break}if(!l)return!1}else o(t,a,n)}lt(i)&&c(t,n)}return!0}var _,b,$={},w=e.modules,C=e.nodeOps;for(_=0;_<Pi.length;++_)for($[Pi[_]]=[],b=0;b<w.length;++b)void 0!==w[b][Pi[_]]&&$[Pi[_]].push(w[b][Pi[_]]);return function(e,n,r,a){if(!n)return void(e&&d(e));var o,c,u=!1,l=[];if(e){var f=lt(e.nodeType);if(!f&&ft(e,n))m(e,n,l,a);else{if(f){if(1===e.nodeType&&e.hasAttribute("server-rendered")&&(e.removeAttribute("server-rendered"),r=!0),r&&y(e,n,l))return g(n,l,!0),e;e=t(e)}if(o=e.elm,c=C.parentNode(o),i(n,l),n.parent&&(n.parent.elm=n.elm,s(n)))for(var v=0;v<$.create.length;++v)$.create[v](Mi,n.parent);null!==c?(C.insertBefore(c,n.elm,C.nextSibling(o)),p(c,[e],0,0)):lt(e.tag)&&d(e)}}else u=!0,i(n,l);return g(n,l,u),n.elm}}function vt(e,t){if(e.data.directives||t.data.directives){var n,r,i,a=e===Mi,o=ht(e.data.directives,e.context),s=ht(t.data.directives,t.context),c=[],u=[];for(n in s)r=o[n],i=s[n],r?(i.oldValue=r.value,gt(i,"update",t,e),i.def&&i.def.componentUpdated&&u.push(i)):(gt(i,"bind",t,e),i.def&&i.def.inserted&&c.push(i));if(c.length){var l=function(){c.forEach(function(n){gt(n,"inserted",t,e)})};a?q(t.data.hook||(t.data.hook={}),"insert",l,"dir-insert"):l()}if(u.length&&q(t.data.hook||(t.data.hook={}),"postpatch",function(){u.forEach(function(n){gt(n,"componentUpdated",t,e)})},"dir-postpatch"),!a)for(n in o)s[n]||gt(o[n],"unbind",e)}}function ht(e,t){var n=Object.create(null);if(!e)return n;var r,i;for(r=0;r<e.length;r++)i=e[r],i.modifiers||(i.modifiers=Ii),n[mt(i)]=i,i.def=je(t.$options,"directives",i.name,!0);return n}function mt(e){return e.rawName||e.name+"."+Object.keys(e.modifiers||{}).join(".")}function gt(e,t,n,r){var i=e.def&&e.def[t];i&&i(n.elm,e,n,r)}function yt(e,t){if(e.data.attrs||t.data.attrs){var n,r,i,a=t.elm,o=e.data.attrs||{},s=t.data.attrs||{};s.__ob__&&(s=t.data.attrs=u({},s));for(n in s)r=s[n],i=o[n],i!==r&&_t(a,n,r);for(n in o)null==s[n]&&($i(n)?a.removeAttributeNS(bi,wi(n)):yi(n)||a.removeAttribute(n))}}function _t(e,t,n){_i(t)?Ci(n)?e.removeAttribute(t):e.setAttribute(t,t):yi(t)?e.setAttribute(t,Ci(n)||"false"===n?"false":"true"):$i(t)?Ci(n)?e.removeAttributeNS(bi,wi(t)):e.setAttributeNS(bi,t,n):Ci(n)?e.removeAttribute(t):e.setAttribute(t,n)}function bt(e,t){var n=t.elm,r=t.data,i=e.data;if(r.staticClass||r.class||i&&(i.staticClass||i.class)){var a=He(t),o=n._transitionClasses;o&&(a=Ve(a,Je(o))),a!==n._prevClass&&(n.setAttribute("class",a),n._prevClass=a)}}function $t(e,t){if(e.data.on||t.data.on){var n=t.data.on||{},r=e.data.on||{},i=t.elm._v_add||(t.elm._v_add=function(e,n,r){t.elm.addEventListener(e,n,r)}),a=t.elm._v_remove||(t.elm._v_remove=function(e,n){t.elm.removeEventListener(e,n)});K(n,r,i,a,t.context)}}function wt(e,t){if(e.data.domProps||t.data.domProps){var n,r,i=t.elm,a=e.data.domProps||{},o=t.data.domProps||{};o.__ob__&&(o=t.data.domProps=u({},o));for(n in a)null==o[n]&&(i[n]=void 0);for(n in o)if("textContent"!==n&&"innerHTML"!==n||!t.children||(t.children.length=0),r=o[n],"value"===n){i._value=r;var s=null==r?"":String(r);i.value===s||i.composing||(i.value=s)}else i[n]=r}}function Ct(e,t){if(e.data&&e.data.style||t.data.style){var n,r,i=t.elm,a=e.data.style||{},o=t.data.style||{};if("string"==typeof o)return void(i.style.cssText=o);var s=o.__ob__;Array.isArray(o)&&(o=t.data.style=d(o)),s&&(o=t.data.style=u({},o));for(r in a)null==o[r]&&(i.style[Ji(r)]="");for(r in o)n=o[r],n!==a[r]&&(i.style[Ji(r)]=null==n?"":n)}}function xt(e,t){if(e.classList)t.indexOf(" ")>-1?t.split(/\s+/).forEach(function(t){return e.classList.add(t)}):e.classList.add(t);else{var n=" "+e.getAttribute("class")+" ";n.indexOf(" "+t+" ")<0&&e.setAttribute("class",(n+t).trim())}}function kt(e,t){if(e.classList)t.indexOf(" ")>-1?t.split(/\s+/).forEach(function(t){return e.classList.remove(t)}):e.classList.remove(t);else{for(var n=" "+e.getAttribute("class")+" ",r=" "+t+" ";n.indexOf(r)>=0;)n=n.replace(r," ");e.setAttribute("class",n.trim())}}function At(e){ea(function(){ea(e)})}function Ot(e,t){(e._transitionClasses||(e._transitionClasses=[])).push(t),xt(e,t)}function Tt(e,t){e._transitionClasses&&r(e._transitionClasses,t),kt(e,t)}function St(e,t,n){var r=Et(e,t),i=r.type,a=r.timeout,o=r.propCount;if(!i)return n();var s=i===Wi?Yi:Xi,c=0,u=function(){e.removeEventListener(s,l),n()},l=function(t){t.target===e&&++c>=o&&u()};setTimeout(function(){c<o&&u()},a+1),e.addEventListener(s,l)}function Et(e,t){var n,r=window.getComputedStyle(e),i=r[Gi+"Delay"].split(", "),a=r[Gi+"Duration"].split(", "),o=jt(i,a),s=r[Qi+"Delay"].split(", "),c=r[Qi+"Duration"].split(", "),u=jt(s,c),l=0,f=0;t===Wi?o>0&&(n=Wi,l=o,f=a.length):t===Zi?u>0&&(n=Zi,l=u,f=c.length):(l=Math.max(o,u),n=l>0?o>u?Wi:Zi:null,f=n?n===Wi?a.length:c.length:0);var d=n===Wi&&ta.test(r[Gi+"Property"]);return{type:n,timeout:l,propCount:f,hasTransform:d}}function jt(e,t){return Math.max.apply(null,t.map(function(t,n){return Lt(t)+Lt(e[n])}))}function Lt(e){return 1e3*Number(e.slice(0,-1))}function Nt(e){var t=e.elm;t._leaveCb&&(t._leaveCb.cancelled=!0,t._leaveCb());var n=Mt(e.data.transition);if(n&&!t._enterCb&&1===t.nodeType){var r=n.css,i=n.type,a=n.enterClass,o=n.enterActiveClass,s=n.appearClass,c=n.appearActiveClass,u=n.beforeEnter,l=n.enter,f=n.afterEnter,d=n.enterCancelled,p=n.beforeAppear,v=n.appear,h=n.afterAppear,m=n.appearCancelled,g=ai.$vnode,y=g&&g.parent?g.parent.context:ai,_=!y._isMounted||!e.isRootInsert;if(!_||v||""===v){var b=_?s:a,$=_?c:o,w=_?p||u:u,C=_&&"function"==typeof v?v:l,x=_?h||f:f,k=_?m||d:d,A=r!==!1&&!Dr,O=C&&(C._length||C.length)>1,T=t._enterCb=Pt(function(){A&&Tt(t,$),T.cancelled?(A&&Tt(t,b),k&&k(t)):x&&x(t),t._enterCb=null});e.data.show||q(e.data.hook||(e.data.hook={}),"insert",function(){var n=t.parentNode,r=n&&n._pending&&n._pending[e.key];r&&r.tag===e.tag&&r.elm._leaveCb&&r.elm._leaveCb(),C&&C(t,T)},"transition-insert"),w&&w(t),A&&(Ot(t,b),Ot(t,$),At(function(){Tt(t,b),T.cancelled||O||St(t,i,T)})),e.data.show&&C&&C(t,T),A||O||T()}}}function Dt(e,t){function n(){m.cancelled||(e.data.show||((r.parentNode._pending||(r.parentNode._pending={}))[e.key]=e),u&&u(r),v&&(Ot(r,s),Ot(r,c),At(function(){Tt(r,s),m.cancelled||h||St(r,o,m)})),l&&l(r,m),v||h||m())}var r=e.elm;r._enterCb&&(r._enterCb.cancelled=!0,r._enterCb());var i=Mt(e.data.transition);if(!i)return t();if(!r._leaveCb&&1===r.nodeType){var a=i.css,o=i.type,s=i.leaveClass,c=i.leaveActiveClass,u=i.beforeLeave,l=i.leave,f=i.afterLeave,d=i.leaveCancelled,p=i.delayLeave,v=a!==!1&&!Dr,h=l&&(l._length||l.length)>1,m=r._leaveCb=Pt(function(){r.parentNode&&r.parentNode._pending&&(r.parentNode._pending[e.key]=null),v&&Tt(r,c),m.cancelled?(v&&Tt(r,s),d&&d(r)):(t(),f&&f(r)),r._leaveCb=null});p?p(n):n()}}function Mt(e){if(e){if("object"==typeof e){var t={};return e.css!==!1&&u(t,na(e.name||"v")),u(t,e),t}return"string"==typeof e?na(e):void 0}}function Pt(e){var t=!1;return function(){t||(t=!0,e())}}function Rt(e,t,n){var r=t.value,i=e.multiple;if(!i||Array.isArray(r)){for(var a,o,s=0,c=e.options.length;s<c;s++)if(o=e.options[s],i)a=m(r,Bt(o))>-1,o.selected!==a&&(o.selected=a);else if(h(Bt(o),r))return void(e.selectedIndex!==s&&(e.selectedIndex=s));i||(e.selectedIndex=-1)}}function It(e,t){for(var n=0,r=t.length;n<r;n++)if(h(Bt(t[n]),e))return!1;return!0}function Bt(e){return"_value"in e?e._value:e.value}function Ft(e){e.target.composing=!0}function Ht(e){e.target.composing=!1,Ut(e.target,"input")}function Ut(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!0,!0),e.dispatchEvent(n)}function zt(e){return!e.child||e.data&&e.data.transition?e:zt(e.child._vnode)}function Vt(e){var t=e&&e.componentOptions;return t&&t.Ctor.options.abstract?Vt(X(t.children)):e}function Jt(e){var t={},n=e.$options;for(var r in n.propsData)t[r]=e[r];var i=n._parentListeners;for(var a in i)t[$r(a)]=i[a].fn;return t}function qt(e,t){return/\d-keep-alive$/.test(t.tag)?e("keep-alive"):null}function Kt(e){for(;e=e.parent;)if(e.data.transition)return!0}function Wt(e){e.elm._moveCb&&e.elm._moveCb(),e.elm._enterCb&&e.elm._enterCb();
}function Zt(e){e.data.newPos=e.elm.getBoundingClientRect()}function Gt(e){var t=e.data.pos,n=e.data.newPos,r=t.left-n.left,i=t.top-n.top;if(r||i){e.data.moved=!0;var a=e.elm.style;a.transform=a.WebkitTransform="translate("+r+"px,"+i+"px)",a.transitionDuration="0s"}}function Yt(e,t){var n=document.createElement("div");return n.innerHTML='<div a="'+e+'">',n.innerHTML.indexOf(t)>0}function Qt(e){return ma.innerHTML=e,ma.textContent}function Xt(e,t){return t&&(e=e.replace(Za,"\n")),e.replace(Ka,"<").replace(Wa,">").replace(Ga,"&").replace(Ya,'"')}function en(e,t){function n(t){f+=t,e=e.substring(t)}function r(){var t=e.match(Ca);if(t){var r={tagName:t[1],attrs:[],start:f};n(t[0].length);for(var i,a;!(i=e.match(xa))&&(a=e.match(ba));)n(a[0].length),r.attrs.push(a);if(i)return r.unarySlash=i[1],n(i[0].length),r.end=f,r}}function i(e){var n=e.tagName,r=e.unarySlash;u&&("p"===s&&Ti(n)&&a("",s),Oi(n)&&s===n&&a("",n));for(var i=l(n)||"html"===n&&"head"===s||!!r,o=e.attrs.length,f=new Array(o),d=0;d<o;d++){var p=e.attrs[d];Oa&&p[0].indexOf('""')===-1&&(""===p[3]&&delete p[3],""===p[4]&&delete p[4],""===p[5]&&delete p[5]);var v=p[3]||p[4]||p[5]||"";f[d]={name:p[1],value:Xt(v,t.shouldDecodeNewlines)}}i||(c.push({tag:n,attrs:f}),s=n,r=""),t.start&&t.start(n,f,i,e.start,e.end)}function a(e,n,r,i){var a;if(null==r&&(r=f),null==i&&(i=f),n){var o=n.toLowerCase();for(a=c.length-1;a>=0&&c[a].tag.toLowerCase()!==o;a--);}else a=0;if(a>=0){for(var u=c.length-1;u>=a;u--)t.end&&t.end(c[u].tag,r,i);c.length=a,s=a&&c[a-1].tag}else"br"===n.toLowerCase()?t.start&&t.start(n,[],!0,r,i):"p"===n.toLowerCase()&&(t.start&&t.start(n,[],!1,r,i),t.end&&t.end(n,r,i))}for(var o,s,c=[],u=t.expectHTML,l=t.isUnaryTag||Or,f=0;e;){if(o=e,s&&Ja(s)){var d=s.toLowerCase(),p=qa[d]||(qa[d]=new RegExp("([\\s\\S]*?)(</"+d+"[^>]*>)","i")),v=0,h=e.replace(p,function(e,n,r){return v=r.length,"script"!==d&&"style"!==d&&"noscript"!==d&&(n=n.replace(/<!--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g,"$1")),t.chars&&t.chars(n),""});f+=e.length-h.length,e=h,a("</"+d+">",d,f-v,f)}else{var m=e.indexOf("<");if(0===m){if(/^<!--/.test(e)){var g=e.indexOf("-->");if(g>=0){n(g+3);continue}}if(/^<!\[/.test(e)){var y=e.indexOf("]>");if(y>=0){n(y+2);continue}}var _=e.match(Aa);if(_){n(_[0].length);continue}var b=e.match(ka);if(b){var $=f;n(b[0].length),a(b[0],b[1],$,f);continue}var w=r();if(w){i(w);continue}}var C=void 0;m>=0?(C=e.substring(0,m),n(m)):(C=e,e=""),t.chars&&t.chars(C)}if(e===o)throw new Error("Error parsing template:\n\n"+e)}a()}function tn(e){function t(){(o||(o=[])).push(e.slice(d,i).trim()),d=i+1}var n,r,i,a,o,s=!1,c=!1,u=0,l=0,f=0,d=0;for(i=0;i<e.length;i++)if(r=n,n=e.charCodeAt(i),s)39===n&&92!==r&&(s=!s);else if(c)34===n&&92!==r&&(c=!c);else if(124!==n||124===e.charCodeAt(i+1)||124===e.charCodeAt(i-1)||u||l||f)switch(n){case 34:c=!0;break;case 39:s=!0;break;case 40:f++;break;case 41:f--;break;case 91:l++;break;case 93:l--;break;case 123:u++;break;case 125:u--}else void 0===a?(d=i+1,a=e.slice(0,i).trim()):t();if(void 0===a?a=e.slice(0,i).trim():0!==d&&t(),o)for(i=0;i<o.length;i++)a=nn(a,o[i]);return a}function nn(e,t){var n=t.indexOf("(");if(n<0)return'_f("'+t+'")('+e+")";var r=t.slice(0,n),i=t.slice(n+1);return'_f("'+r+'")('+e+","+i}function rn(e,t){var n=t?eo(t):Qa;if(n.test(e)){for(var r,i,a=[],o=n.lastIndex=0;r=n.exec(e);){i=r.index,i>o&&a.push(JSON.stringify(e.slice(o,i)));var s=tn(r[1].trim());a.push("_s("+s+")"),o=i+r[0].length}return o<e.length&&a.push(JSON.stringify(e.slice(o))),a.join("+")}}function an(e){console.error("[Vue parser]: "+e)}function on(e,t){return e?e.map(function(e){return e[t]}).filter(function(e){return e}):[]}function sn(e,t,n){(e.props||(e.props=[])).push({name:t,value:n})}function cn(e,t,n){(e.attrs||(e.attrs=[])).push({name:t,value:n})}function un(e,t,n,r,i,a){(e.directives||(e.directives=[])).push({name:t,rawName:n,value:r,arg:i,modifiers:a})}function ln(e,t,n,r,i){r&&r.capture&&(delete r.capture,t="!"+t);var a;r&&r.native?(delete r.native,a=e.nativeEvents||(e.nativeEvents={})):a=e.events||(e.events={});var o={value:n,modifiers:r},s=a[t];Array.isArray(s)?i?s.unshift(o):s.push(o):s?a[t]=i?[o,s]:[s,o]:a[t]=o}function fn(e,t,n){var r=dn(e,":"+t)||dn(e,"v-bind:"+t);if(null!=r)return r;if(n!==!1){var i=dn(e,t);if(null!=i)return JSON.stringify(i)}}function dn(e,t){var n;if(null!=(n=e.attrsMap[t]))for(var r=e.attrsList,i=0,a=r.length;i<a;i++)if(r[i].name===t){r.splice(i,1);break}return n}function pn(e,t){Ta=t.warn||an,Sa=t.getTagNamespace||Or,Ea=t.mustUseProp||Or,ja=t.isPreTag||Or,La=on(t.modules,"preTransformNode"),Na=on(t.modules,"transformNode"),Da=on(t.modules,"postTransformNode"),Ma=t.delimiters;var n,r,i=[],a=t.preserveWhitespace!==!1,o=!1,s=!1;return en(e,{expectHTML:t.expectHTML,isUnaryTag:t.isUnaryTag,shouldDecodeNewlines:t.shouldDecodeNewlines,start:function(e,a,c){function u(e){}var l=r&&r.ns||Sa(e);t.isIE&&"svg"===l&&(a=En(a));var f={type:1,tag:e,attrsList:a,attrsMap:On(a,t.isIE),parent:r,children:[]};l&&(f.ns=l),Sn(f)&&(f.forbidden=!0);for(var d=0;d<La.length;d++)La[d](f,t);if(o||(vn(f),f.pre&&(o=!0)),ja(f.tag)&&(s=!0),o)hn(f);else{yn(f),_n(f),$n(f),mn(f),f.plain=!f.key&&!a.length,gn(f),wn(f),Cn(f);for(var p=0;p<Na.length;p++)Na[p](f,t);xn(f)}n||(n=f,u(n)),r&&!f.forbidden&&(f.else?bn(f,r):(r.children.push(f),f.parent=r)),c||(r=f,i.push(f));for(var v=0;v<Da.length;v++)Da[v](f,t)},end:function(){var e=i[i.length-1],t=e.children[e.children.length-1];t&&3===t.type&&" "===t.text&&e.children.pop(),i.length-=1,r=i[i.length-1],e.pre&&(o=!1),ja(e.tag)&&(s=!1)},chars:function(e){if(r&&(e=s||e.trim()?uo(e):a&&r.children.length?" ":"")){var t;!o&&" "!==e&&(t=rn(e,Ma))?r.children.push({type:2,expression:t,text:e}):(e=e.replace(co,""),r.children.push({type:3,text:e}))}}}),n}function vn(e){null!=dn(e,"v-pre")&&(e.pre=!0)}function hn(e){var t=e.attrsList.length;if(t)for(var n=e.attrs=new Array(t),r=0;r<t;r++)n[r]={name:e.attrsList[r].name,value:JSON.stringify(e.attrsList[r].value)};else e.pre||(e.plain=!0)}function mn(e){var t=fn(e,"key");t&&(e.key=t)}function gn(e){var t=fn(e,"ref");t&&(e.ref=t,e.refInFor=kn(e))}function yn(e){var t;if(t=dn(e,"v-for")){var n=t.match(no);if(!n)return;e.for=n[2].trim();var r=n[1].trim(),i=r.match(ro);i?(e.alias=i[1].trim(),e.iterator1=i[2].trim(),i[3]&&(e.iterator2=i[3].trim())):e.alias=r}}function _n(e){var t=dn(e,"v-if");t&&(e.if=t),null!=dn(e,"v-else")&&(e.else=!0)}function bn(e,t){var n=Tn(t.children);n&&n.if&&(n.elseBlock=e)}function $n(e){var t=dn(e,"v-once");null!=t&&(e.once=!0)}function wn(e){if("slot"===e.tag)e.slotName=fn(e,"name");else{var t=fn(e,"slot");t&&(e.slotTarget=t)}}function Cn(e){var t;(t=fn(e,"is"))&&(e.component=t),null!=dn(e,"inline-template")&&(e.inlineTemplate=!0)}function xn(e){var t,n,r,i,a,o,s,c,u=e.attrsList;for(t=0,n=u.length;t<n;t++)if(r=i=u[t].name,a=u[t].value,to.test(r))if(e.hasBindings=!0,s=An(r),s&&(r=r.replace(so,"")),io.test(r))r=r.replace(io,""),s&&s.prop&&(c=!0,r=$r(r),"innerHtml"===r&&(r="innerHTML")),c||Ea(r)?sn(e,r,a):cn(e,r,a);else if(ao.test(r))r=r.replace(ao,""),ln(e,r,a,s);else{r=r.replace(to,"");var l=r.match(oo);l&&(o=l[1])&&(r=r.slice(0,-(o.length+1))),un(e,r,i,a,o,s)}else cn(e,r,JSON.stringify(a))}function kn(e){for(var t=e;t;){if(void 0!==t.for)return!0;t=t.parent}return!1}function An(e){var t=e.match(so);if(t){var n={};return t.forEach(function(e){n[e.slice(1)]=!0}),n}}function On(e,t){for(var n={},r=0,i=e.length;r<i;r++)n[e[r].name]=e[r].value;return n}function Tn(e){for(var t=e.length;t--;)if(e[t].tag)return e[t]}function Sn(e){return"style"===e.tag||"script"===e.tag&&(!e.attrsMap.type||"text/javascript"===e.attrsMap.type)}function En(e){for(var t=[],n=0;n<e.length;n++){var r=e[n];lo.test(r.name)||(r.name=r.name.replace(fo,""),t.push(r))}return t}function jn(e,t){e&&(Pa=po(t.staticKeys||""),Ra=t.isReservedTag||function(){return!1},Nn(e),Dn(e,!1))}function Ln(e){return n("type,tag,attrsList,attrsMap,plain,parent,children,attrs"+(e?","+e:""))}function Nn(e){if(e.static=Mn(e),1===e.type)for(var t=0,n=e.children.length;t<n;t++){var r=e.children[t];Nn(r),r.static||(e.static=!1)}}function Dn(e,t){if(1===e.type){if(e.once||e.static)return e.staticRoot=!0,void(e.staticInFor=t);if(e.children)for(var n=0,r=e.children.length;n<r;n++)Dn(e.children[n],t||!!e.for)}}function Mn(e){return 2!==e.type&&(3===e.type||!(!e.pre&&(e.hasBindings||e.if||e.for||yr(e.tag)||!Ra(e.tag)||Pn(e)||!Object.keys(e).every(Pa))))}function Pn(e){for(;e.parent;){if(e=e.parent,"template"!==e.tag)return!1;if(e.for)return!0}return!1}function Rn(e,t){var n=t?"nativeOn:{":"on:{";for(var r in e)n+='"'+r+'":'+In(e[r])+",";return n.slice(0,-1)+"}"}function In(e){if(e){if(Array.isArray(e))return"["+e.map(In).join(",")+"]";if(e.modifiers){var t="",n=[];for(var r in e.modifiers)mo[r]?t+=mo[r]:n.push(r);n.length&&(t=Bn(n)+t);var i=vo.test(e.value)?e.value+"($event)":e.value;return"function($event){"+t+i+"}"}return vo.test(e.value)?e.value:"function($event){"+e.value+"}"}return"function(){}"}function Bn(e){var t=1===e.length?Fn(e[0]):Array.prototype.concat.apply([],e.map(Fn));return Array.isArray(t)?"if("+t.map(function(e){return"$event.keyCode!=="+e}).join("&&")+")return;":"if($event.keyCode!=="+t+")return;"}function Fn(e){return parseInt(e,10)||ho[e]||"_k("+JSON.stringify(e)+")"}function Hn(e,t){e.wrapData=function(e){return"_b("+e+","+t.value+(t.modifiers&&t.modifiers.prop?",true":"")+")"}}function Un(e,t){var n=Ua,r=Ua=[];za=t,Ia=t.warn||an,Ba=on(t.modules,"transformCode"),Fa=on(t.modules,"genData"),Ha=t.directives||{};var i=e?zn(e):'_h("div")';return Ua=n,{render:"with(this){return "+i+"}",staticRenderFns:r}}function zn(e){if(e.staticRoot&&!e.staticProcessed)return e.staticProcessed=!0,Ua.push("with(this){return "+zn(e)+"}"),"_m("+(Ua.length-1)+(e.staticInFor?",true":"")+")";if(e.for&&!e.forProcessed)return qn(e);if(e.if&&!e.ifProcessed)return Vn(e);if("template"!==e.tag||e.slotTarget){if("slot"===e.tag)return Qn(e);var t;if(e.component)t=Xn(e);else{var n=Kn(e),r=e.inlineTemplate?null:Zn(e);t="_h('"+e.tag+"'"+(n?","+n:"")+(r?","+r:"")+")"}for(var i=0;i<Ba.length;i++)t=Ba[i](e,t);return t}return Zn(e)||"void 0"}function Vn(e){var t=e.if;return e.ifProcessed=!0,"("+t+")?"+zn(e)+":"+Jn(e)}function Jn(e){return e.elseBlock?zn(e.elseBlock):"_e()"}function qn(e){var t=e.for,n=e.alias,r=e.iterator1?","+e.iterator1:"",i=e.iterator2?","+e.iterator2:"";return e.forProcessed=!0,"_l(("+t+"),function("+n+r+i+"){return "+zn(e)+"})"}function Kn(e){if(!e.plain){var t="{",n=Wn(e);n&&(t+=n+","),e.key&&(t+="key:"+e.key+","),e.ref&&(t+="ref:"+e.ref+","),e.refInFor&&(t+="refInFor:true,"),e.component&&(t+='tag:"'+e.tag+'",'),e.slotTarget&&(t+="slot:"+e.slotTarget+",");for(var r=0;r<Fa.length;r++)t+=Fa[r](e);if(e.attrs&&(t+="attrs:{"+er(e.attrs)+"},"),e.props&&(t+="domProps:{"+er(e.props)+"},"),e.events&&(t+=Rn(e.events)+","),e.nativeEvents&&(t+=Rn(e.nativeEvents,!0)+","),e.inlineTemplate){var i=e.children[0];if(1===i.type){var a=Un(i,za);t+="inlineTemplate:{render:function(){"+a.render+"},staticRenderFns:["+a.staticRenderFns.map(function(e){return"function(){"+e+"}"}).join(",")+"]}"}}return t=t.replace(/,$/,"")+"}",e.wrapData&&(t=e.wrapData(t)),t}}function Wn(e){var t=e.directives;if(t){var n,r,i,a,o="directives:[",s=!1;for(n=0,r=t.length;n<r;n++){i=t[n],a=!0;var c=Ha[i.name]||go[i.name];c&&(a=!!c(e,i,Ia)),a&&(s=!0,o+='{name:"'+i.name+'",rawName:"'+i.rawName+'"'+(i.value?",value:("+i.value+"),expression:"+JSON.stringify(i.value):"")+(i.arg?',arg:"'+i.arg+'"':"")+(i.modifiers?",modifiers:"+JSON.stringify(i.modifiers):"")+"},")}return s?o.slice(0,-1)+"]":void 0}}function Zn(e){if(e.children.length)return"["+e.children.map(Gn).join(",")+"]"}function Gn(e){return 1===e.type?zn(e):Yn(e)}function Yn(e){return 2===e.type?e.expression:JSON.stringify(e.text)}function Qn(e){var t=e.slotName||'"default"',n=Zn(e);return n?"_t("+t+","+n+")":"_t("+t+")"}function Xn(e){var t=e.inlineTemplate?null:Zn(e);return"_h("+e.component+","+Kn(e)+(t?","+t:"")+")"}function er(e){for(var t="",n=0;n<e.length;n++){var r=e[n];t+='"'+r.name+'":'+r.value+","}return t.slice(0,-1)}function tr(e,t){var n=pn(e.trim(),t);jn(n,t);var r=Un(n,t);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}}function nr(e,t){var n=(t.warn||an,dn(e,"class"));n&&(e.staticClass=JSON.stringify(n));var r=fn(e,"class",!1);r&&(e.classBinding=r)}function rr(e){var t="";return e.staticClass&&(t+="staticClass:"+e.staticClass+","),e.classBinding&&(t+="class:"+e.classBinding+","),t}function ir(e){var t=fn(e,"style",!1);t&&(e.styleBinding=t)}function ar(e){return e.styleBinding?"style:("+e.styleBinding+"),":""}function or(e,t,n){Va=n;var r=t.value,i=t.modifiers,a=e.tag,o=e.attrsMap.type;return"select"===a?lr(e,r):"input"===a&&"checkbox"===o?sr(e,r):"input"===a&&"radio"===o?cr(e,r):ur(e,r,i),!0}function sr(e,t){var n=fn(e,"value")||"null",r=fn(e,"true-value")||"true",i=fn(e,"false-value")||"false";sn(e,"checked","Array.isArray("+t+")?_i("+t+","+n+")>-1:_q("+t+","+r+")"),ln(e,"change","var $$a="+t+",$$el=$event.target,$$c=$$el.checked?("+r+"):("+i+");if(Array.isArray($$a)){var $$v="+n+",$$i=_i($$a,$$v);if($$c){$$i<0&&("+t+"=$$a.concat($$v))}else{$$i>-1&&("+t+"=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{"+t+"=$$c}",null,!0)}function cr(e,t){var n=fn(e,"value")||"null";sn(e,"checked","_q("+t+","+n+")"),ln(e,"change",t+"="+n,null,!0)}function ur(e,t,n){var r=e.attrsMap.type,i=n||{},a=i.lazy,o=i.number,s=i.trim,c=a||Nr&&"range"===r?"change":"input",u=!a&&"range"!==r,l="input"===e.tag||"textarea"===e.tag,f=l?"$event.target.value"+(s?".trim()":""):"$event",d=o||"number"===r?t+"=_n("+f+")":t+"="+f;l&&u&&(d="if($event.target.composing)return;"+d),sn(e,"value",l?"_s("+t+")":"("+t+")"),ln(e,c,d,null,!0)}function lr(e,t){var n=t+'=Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){return "_value" in o ? o._value : o.value})'+(null==e.attrsMap.multiple?"[0]":"");ln(e,"change",n,null,!0)}function fr(e,t){t.value&&sn(e,"textContent","_s("+t.value+")")}function dr(e,t){t.value&&sn(e,"innerHTML","_s("+t.value+")")}function pr(e,t){return t=t?u(u({},Co),t):Co,tr(e,t)}function vr(e,t,n){var r=(t&&t.warn||li,t&&t.delimiters?String(t.delimiters)+e:e);if(wo[r])return wo[r];var i={},a=pr(e,t);i.render=hr(a.render);var o=a.staticRenderFns.length;i.staticRenderFns=new Array(o);for(var s=0;s<o;s++)i.staticRenderFns[s]=hr(a.staticRenderFns[s]);return wo[r]=i}function hr(e){try{return new Function(e)}catch(e){return p}}function mr(e){if(e.outerHTML)return e.outerHTML;var t=document.createElement("div");return t.appendChild(e.cloneNode(!0)),t.innerHTML}var gr,yr=n("slot,component",!0),_r=Object.prototype.hasOwnProperty,br=/-(\w)/g,$r=o(function(e){return e.replace(br,function(e,t){return t?t.toUpperCase():""})}),wr=o(function(e){return e.charAt(0).toUpperCase()+e.slice(1)}),Cr=/([^-])([A-Z])/g,xr=o(function(e){return e.replace(Cr,"$1-$2").replace(Cr,"$1-$2").toLowerCase()}),kr=Object.prototype.toString,Ar="[object Object]",Or=function(){return!1},Tr={optionMergeStrategies:Object.create(null),silent:!1,devtools:!1,errorHandler:null,ignoredElements:null,keyCodes:Object.create(null),isReservedTag:Or,isUnknownElement:Or,getTagNamespace:p,mustUseProp:Or,_assetTypes:["component","directive","filter"],_lifecycleHooks:["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated"],_maxUpdateCount:100,_isServer:!1},Sr=/[^\w\.\$]/,Er="__proto__"in{},jr="undefined"!=typeof window&&"[object Object]"!==Object.prototype.toString.call(window),Lr=jr&&window.navigator.userAgent.toLowerCase(),Nr=Lr&&/msie|trident/.test(Lr),Dr=Lr&&Lr.indexOf("msie 9.0")>0,Mr=Lr&&Lr.indexOf("edge/")>0,Pr=Lr&&Lr.indexOf("android")>0,Rr=Lr&&/iphone|ipad|ipod|ios/.test(Lr),Ir=jr&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__,Br=function(){function e(){r=!1;var e=n.slice(0);n.length=0;for(var t=0;t<e.length;t++)e[t]()}var t,n=[],r=!1;if("undefined"!=typeof Promise&&b(Promise)){var i=Promise.resolve();t=function(){i.then(e),Rr&&setTimeout(p)}}else if("undefined"==typeof MutationObserver||!b(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())t=function(){setTimeout(e,0)};else{var a=1,o=new MutationObserver(e),s=document.createTextNode(String(a));o.observe(s,{characterData:!0}),t=function(){a=(a+1)%2,s.data=String(a)}}return function(e,i){var a=i?function(){e.call(i)}:e;n.push(a),r||(r=!0,t())}}();gr="undefined"!=typeof Set&&b(Set)?Set:function(){function e(){this.set=Object.create(null)}return e.prototype.has=function(e){return void 0!==this.set[e]},e.prototype.add=function(e){this.set[e]=1},e.prototype.clear=function(){this.set=Object.create(null)},e}();var Fr=0,Hr=function(){this.id=Fr++,this.subs=[]};Hr.prototype.addSub=function(e){this.subs.push(e)},Hr.prototype.removeSub=function(e){r(this.subs,e)},Hr.prototype.depend=function(){Hr.target&&Hr.target.addDep(this)},Hr.prototype.notify=function(){for(var e=this.subs.slice(),t=0,n=e.length;t<n;t++)e[t].update()},Hr.target=null;var Ur=[],zr=[],Vr={},Jr=!1,qr=!1,Kr=0,Wr=0,Zr=function(e,t,n,r){void 0===r&&(r={}),this.vm=e,e._watchers.push(this),this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.expression=t.toString(),this.cb=n,this.id=++Wr,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new gr,this.newDepIds=new gr,"function"==typeof t?this.getter=t:(this.getter=_(t),this.getter||(this.getter=function(){})),this.value=this.lazy?void 0:this.get()};Zr.prototype.get=function(){$(this);var e=this.getter.call(this.vm,this.vm);return this.deep&&A(e),w(),this.cleanupDeps(),e},Zr.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},Zr.prototype.cleanupDeps=function(){for(var e=this,t=this.deps.length;t--;){var n=e.deps[t];e.newDepIds.has(n.id)||n.removeSub(e)}var r=this.depIds;this.depIds=this.newDepIds,this.newDepIds=r,this.newDepIds.clear(),r=this.deps,this.deps=this.newDeps,this.newDeps=r,this.newDeps.length=0},Zr.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():k(this)},Zr.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||l(e)||this.deep){var t=this.value;if(this.value=e,this.user)try{this.cb.call(this.vm,e,t)}catch(e){if(!Tr.errorHandler)throw e;Tr.errorHandler.call(null,e,this.vm)}else this.cb.call(this.vm,e,t)}}},Zr.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},Zr.prototype.depend=function(){for(var e=this,t=this.deps.length;t--;)e.deps[t].depend()},Zr.prototype.teardown=function(){var e=this;if(this.active){this.vm._isBeingDestroyed||this.vm._vForRemoving||r(this.vm._watchers,this);for(var t=this.deps.length;t--;)e.deps[t].removeSub(e);this.active=!1}};var Gr=new gr,Yr=Array.prototype,Qr=Object.create(Yr);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(e){var t=Yr[e];y(Qr,e,function(){for(var n=arguments,r=arguments.length,i=new Array(r);r--;)i[r]=n[r];var a,o=t.apply(this,i),s=this.__ob__;switch(e){case"push":a=i;break;case"unshift":a=i;break;case"splice":a=i.slice(2)}return a&&s.observeArray(a),s.dep.notify(),o})});var Xr=Object.getOwnPropertyNames(Qr),ei={shouldConvert:!0,isSettingProps:!1},ti=function(e){if(this.value=e,this.dep=new Hr,this.vmCount=0,y(e,"__ob__",this),Array.isArray(e)){var t=Er?O:T;t(e,Qr,Xr),this.observeArray(e)}else this.walk(e)};ti.prototype.walk=function(e){for(var t=Object.keys(e),n=0;n<t.length;n++)E(e,t[n],e[t[n]])},ti.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)S(e[t])};var ni={enumerable:!0,configurable:!0,get:p,set:p},ri=function(e,t,n,r,i,a,o,s){this.tag=e,this.data=t,this.children=n,this.text=r,this.elm=i,this.ns=a,this.context=o,this.functionalContext=void 0,this.key=t&&t.key,this.componentOptions=s,this.child=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1},ii=function(){var e=new ri;return e.text="",e.isComment=!0,e},ai=null,oi={init:oe,prepatch:se,insert:ce,destroy:ue},si=Object.keys(oi),ci=0;we(Ce),U(Ce),$e(Ce),te(Ce),ye(Ce);var ui,li=p,fi=Tr.optionMergeStrategies;fi.data=function(e,t,n){return n?e||t?function(){var r="function"==typeof t?t.call(n):t,i="function"==typeof e?e.call(n):void 0;return r?xe(r,i):i}:void 0:t?"function"!=typeof t?e:e?function(){return xe(t.call(this),e.call(this))}:t:e},Tr._lifecycleHooks.forEach(function(e){fi[e]=ke}),Tr._assetTypes.forEach(function(e){fi[e+"s"]=Ae}),fi.watch=function(e,t){if(!t)return e;if(!e)return t;var n={};u(n,e);for(var r in t){var i=n[r],a=t[r];i&&!Array.isArray(i)&&(i=[i]),n[r]=i?i.concat(a):[a]}return n},fi.props=fi.methods=fi.computed=function(e,t){if(!t)return e;if(!e)return t;var n=Object.create(null);return u(n,e),u(n,t),n};var di=function(e,t){return void 0===t?e:t},pi=Object.freeze({defineReactive:E,_toString:e,toNumber:t,makeMap:n,isBuiltInTag:yr,remove:r,hasOwn:i,isPrimitive:a,cached:o,camelize:$r,capitalize:wr,hyphenate:xr,bind:s,toArray:c,extend:u,isObject:l,isPlainObject:f,toObject:d,noop:p,no:Or,genStaticKeys:v,looseEqual:h,looseIndexOf:m,isReserved:g,def:y,parsePath:_,hasProto:Er,inBrowser:jr,UA:Lr,isIE:Nr,isIE9:Dr,isEdge:Mr,isAndroid:Pr,isIOS:Rr,devtools:Ir,nextTick:Br,get _Set(){return gr},mergeOptions:Ee,resolveAsset:je,warn:li,formatComponentName:ui,validateProp:Le}),vi={name:"keep-alive",abstract:!0,created:function(){this.cache=Object.create(null)},render:function(){var e=X(this.$slots.default);if(e&&e.componentOptions){var t=e.componentOptions,n=null==e.key?t.Ctor.cid+"::"+t.tag:e.key;this.cache[n]?e.child=this.cache[n].child:this.cache[n]=e,e.data.keepAlive=!0}return e},destroyed:function(){var e=this;for(var t in this.cache){var n=e.cache[t];ne(n.child,"deactivated"),n.child.$destroy()}}},hi={KeepAlive:vi};Fe(Ce),Object.defineProperty(Ce.prototype,"$isServer",{get:function(){return Tr._isServer}}),Ce.version="2.0.3";var mi,gi=n("value,selected,checked,muted"),yi=n("contenteditable,draggable,spellcheck"),_i=n("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),bi="http://www.w3.org/1999/xlink",$i=function(e){return":"===e.charAt(5)&&"xlink"===e.slice(0,5)},wi=function(e){return $i(e)?e.slice(6,e.length):""},Ci=function(e){return null==e||e===!1},xi={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},ki=n("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template"),Ai=n("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr",!0),Oi=n("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source",!0),Ti=n("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track",!0),Si=n("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font,font-face,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Ei=function(e){return"pre"===e},ji=function(e){return ki(e)||Si(e)},Li=Object.create(null),Ni=Object.freeze({createElement:Ze,createElementNS:Ge,createTextNode:Ye,createComment:Qe,insertBefore:Xe,removeChild:et,appendChild:tt,parentNode:nt,nextSibling:rt,tagName:it,setTextContent:at,childNodes:ot,setAttribute:st}),Di={create:function(e,t){ct(t)},update:function(e,t){e.data.ref!==t.data.ref&&(ct(e,!0),ct(t))},destroy:function(e){ct(e,!0)}},Mi=new ri("",{},[]),Pi=["create","update","remove","destroy"],Ri={create:vt,update:vt,destroy:function(e){vt(e,Mi)}},Ii=Object.create(null),Bi=[Di,Ri],Fi={create:yt,update:yt},Hi={create:bt,update:bt},Ui={create:$t,update:$t},zi={create:wt,update:wt},Vi=["Webkit","Moz","ms"],Ji=o(function(e){if(mi=mi||document.createElement("div"),e=$r(e),"filter"!==e&&e in mi.style)return e;for(var t=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<Vi.length;n++){var r=Vi[n]+t;if(r in mi.style)return r}}),qi={create:Ct,update:Ct},Ki=jr&&!Dr,Wi="transition",Zi="animation",Gi="transition",Yi="transitionend",Qi="animation",Xi="animationend";Ki&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(Gi="WebkitTransition",Yi="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Qi="WebkitAnimation",Xi="webkitAnimationEnd"));var ea=jr&&window.requestAnimationFrame||setTimeout,ta=/\b(transform|all)(,|$)/,na=o(function(e){return{enterClass:e+"-enter",leaveClass:e+"-leave",appearClass:e+"-enter",enterActiveClass:e+"-enter-active",leaveActiveClass:e+"-leave-active",appearActiveClass:e+"-enter-active"}}),ra=jr?{create:function(e,t){t.data.show||Nt(t)},remove:function(e,t){e.data.show?t():Dt(e,t)}}:{},ia=[Fi,Hi,Ui,zi,qi,ra],aa=ia.concat(Bi),oa=pt({nodeOps:Ni,modules:aa});Dr&&document.addEventListener("selectionchange",function(){var e=document.activeElement;e&&e.vmodel&&Ut(e,"input")});var sa={inserted:function(e,t,n){if("select"===n.tag){var r=function(){Rt(e,t,n.context)};r(),(Nr||Mr)&&setTimeout(r,0)}else"textarea"!==n.tag&&"text"!==e.type||t.modifiers.lazy||(Pr||(e.addEventListener("compositionstart",Ft),e.addEventListener("compositionend",Ht)),Dr&&(e.vmodel=!0))},componentUpdated:function(e,t,n){if("select"===n.tag){Rt(e,t,n.context);var r=e.multiple?t.value.some(function(t){return It(t,e.options)}):t.value!==t.oldValue&&It(t.value,e.options);r&&Ut(e,"change")}}},ca={bind:function(e,t,n){var r=t.value;n=zt(n);var i=n.data&&n.data.transition;r&&i&&!Dr&&Nt(n);var a="none"===e.style.display?"":e.style.display;e.style.display=r?a:"none",e.__vOriginalDisplay=a},update:function(e,t,n){var r=t.value,i=t.oldValue;if(r!==i){n=zt(n);var a=n.data&&n.data.transition;a&&!Dr?r?(Nt(n),e.style.display=e.__vOriginalDisplay):Dt(n,function(){e.style.display="none"}):e.style.display=r?e.__vOriginalDisplay:"none"}}},ua={model:sa,show:ca},la={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String},fa={name:"transition",props:la,abstract:!0,render:function(e){var t=this,n=this.$slots.default;if(n&&(n=n.filter(function(e){return e.tag}),n.length)){var r=this.mode,i=n[0];if(Kt(this.$vnode))return i;var a=Vt(i);if(!a)return i;if(this._leaving)return qt(e,i);var o=a.key=null==a.key||a.isStatic?"__v"+(a.tag+this._uid)+"__":a.key,s=(a.data||(a.data={})).transition=Jt(this),c=this._vnode,l=Vt(c);if(a.data.directives&&a.data.directives.some(function(e){return"show"===e.name})&&(a.data.show=!0),l&&l.data&&l.key!==o){var f=l.data.transition=u({},s);if("out-in"===r)return this._leaving=!0,q(f,"afterLeave",function(){t._leaving=!1,t.$forceUpdate()},o),qt(e,i);if("in-out"===r){var d,p=function(){d()};q(s,"afterEnter",p,o),q(s,"enterCancelled",p,o),q(f,"delayLeave",function(e){d=e},o)}}return i}}},da=u({tag:String,moveClass:String},la);delete da.mode;var pa={props:da,render:function(e){for(var t=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,i=this.$slots.default||[],a=this.children=[],o=Jt(this),s=0;s<i.length;s++){var c=i[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(a.push(c),n[c.key]=c,(c.data||(c.data={})).transition=o)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var d=r[f];d.data.transition=o,d.data.pos=d.elm.getBoundingClientRect(),n[d.key]?u.push(d):l.push(d)}this.kept=e(t,null,u),this.removed=l}return e(t,null,a)},beforeUpdate:function(){this.__patch__(this._vnode,this.kept,!1,!0),this._vnode=this.kept},updated:function(){var e=this.prevChildren,t=this.moveClass||this.name+"-move";if(e.length&&this.hasMove(e[0].elm,t)){e.forEach(Wt),e.forEach(Zt),e.forEach(Gt);document.body.offsetHeight;e.forEach(function(e){if(e.data.moved){var n=e.elm,r=n.style;Ot(n,t),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Yi,n._moveCb=function e(r){r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Yi,e),n._moveCb=null,Tt(n,t))})}})}},methods:{hasMove:function(e,t){if(!Ki)return!1;if(null!=this._hasMove)return this._hasMove;Ot(e,t);var n=Et(e);return Tt(e,t),this._hasMove=n.hasTransform}}},va={Transition:fa,TransitionGroup:pa};Ce.config.isUnknownElement=Ke,Ce.config.isReservedTag=ji,Ce.config.getTagNamespace=qe,Ce.config.mustUseProp=gi,u(Ce.options.directives,ua),u(Ce.options.components,va),Ce.prototype.__patch__=Tr._isServer?p:oa,Ce.prototype.$mount=function(e,t){return e=e&&!Tr._isServer?We(e):void 0,this._mount(e,t)},setTimeout(function(){Tr.devtools&&Ir&&Ir.emit("init",Ce)},0);var ha=!!jr&&Yt("\n","&#10;"),ma=document.createElement("div"),ga=/([^\s"'<>\/=]+)/,ya=/(?:=)/,_a=[/"([^"]*)"+/.source,/'([^']*)'+/.source,/([^\s"'=<>`]+)/.source],ba=new RegExp("^\\s*"+ga.source+"(?:\\s*("+ya.source+")\\s*(?:"+_a.join("|")+"))?"),$a="[a-zA-Z_][\\w\\-\\.]*",wa="((?:"+$a+"\\:)?"+$a+")",Ca=new RegExp("^<"+wa),xa=/^\s*(\/?)>/,ka=new RegExp("^<\\/"+wa+"[^>]*>"),Aa=/^<!DOCTYPE [^>]+>/i,Oa=!1;"x".replace(/x(.)?/g,function(e,t){Oa=""===t});var Ta,Sa,Ea,ja,La,Na,Da,Ma,Pa,Ra,Ia,Ba,Fa,Ha,Ua,za,Va,Ja=n("script,style",!0),qa={},Ka=/&lt;/g,Wa=/&gt;/g,Za=/&#10;/g,Ga=/&amp;/g,Ya=/&quot;/g,Qa=/\{\{((?:.|\n)+?)\}\}/g,Xa=/[-.*+?^${}()|[\]\/\\]/g,eo=o(function(e){var t=e[0].replace(Xa,"\\$&"),n=e[1].replace(Xa,"\\$&");return new RegExp(t+"((?:.|\\n)+?)"+n,"g")}),to=/^v-|^@|^:/,no=/(.*?)\s+(?:in|of)\s+(.*)/,ro=/\(([^,]*),([^,]*)(?:,([^,]*))?\)/,io=/^:|^v-bind:/,ao=/^@|^v-on:/,oo=/:(.*)$/,so=/\.[^\.]+/g,co=/\u2028|\u2029/g,uo=o(Qt),lo=/^xmlns:NS\d+/,fo=/^NS\d+:/,po=o(Ln),vo=/^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*\s*$/,ho={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},mo={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:"if($event.target !== $event.currentTarget)return;"},go={bind:Hn,cloak:p},yo=(new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b"),{staticKeys:["staticClass"],transformNode:nr,genData:rr}),_o={transformNode:ir,genData:ar},bo=[yo,_o],$o={model:or,text:fr,html:dr},wo=Object.create(null),Co={isIE:Nr,expectHTML:!0,modules:bo,staticKeys:v(bo),directives:$o,isReservedTag:ji,isUnaryTag:Ai,mustUseProp:gi,getTagNamespace:qe,isPreTag:Ei},xo=o(function(e){var t=We(e);return t&&t.innerHTML}),ko=Ce.prototype.$mount;return Ce.prototype.$mount=function(e,t){if(e=e&&We(e),e===document.body||e===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=xo(r));else{if(!r.nodeType)return this;r=r.innerHTML}else e&&(r=mr(e));if(r){var i=vr(r,{warn:li,shouldDecodeNewlines:ha,delimiters:n.delimiters},this),a=i.render,o=i.staticRenderFns;n.render=a,n.staticRenderFns=o}}return ko.call(this,e,t)},Ce.compile=vr,Ce});

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./due_date_filters.js": 65,
	"./due_date_filters.js.es6": 65
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 159;


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./modal_mixins.js": 66,
	"./modal_mixins.js.es6": 66,
	"./sortable_default_options.js": 67,
	"./sortable_default_options.js.es6": 67
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./issue.js": 68,
	"./issue.js.es6": 68,
	"./label.js": 69,
	"./label.js.es6": 69,
	"./list.js": 70,
	"./list.js.es6": 70,
	"./milestone.js": 71,
	"./milestone.js.es6": 71,
	"./user.js": 72,
	"./user.js.es6": 72
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 161;


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./board_service.js": 73,
	"./board_service.js.es6": 73
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./boards_store.js": 74,
	"./boards_store.js.es6": 74,
	"./modal_store.js": 75,
	"./modal_store.js.es6": 75
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;


/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, space-before-function-paren, one-var */
  /* global Vue */
  /* global Sortable */

  __webpack_require__(244);
  __webpack_require__(246);
  __webpack_require__(247);

  (function () {
    var Store = gl.issueBoards.BoardsStore;

    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    gl.issueBoards.Board = Vue.extend({
      template: '#js-board-template',
      components: {
        'board-list': gl.issueBoards.BoardList,
        'board-delete': gl.issueBoards.BoardDelete,
        'board-blank-state': gl.issueBoards.BoardBlankState
      },
      props: {
        list: Object,
        disabled: Boolean,
        issueLinkBase: String,
        rootPath: String
      },
      data: function data() {
        return {
          detailIssue: Store.detail,
          filters: Store.state.filters
        };
      },

      watch: {
        filters: {
          handler: function handler() {
            this.list.page = 1;
            this.list.getIssues(true);
          },

          deep: true
        },
        detailIssue: {
          handler: function handler() {
            if (!Object.keys(this.detailIssue.issue).length) return;

            var issue = this.list.findIssue(this.detailIssue.issue.id);

            if (issue) {
              var offsetLeft = this.$el.offsetLeft;
              var boardsList = document.querySelectorAll('.boards-list')[0];
              var left = boardsList.scrollLeft - offsetLeft;
              var right = offsetLeft + this.$el.offsetWidth;

              if (window.innerWidth > 768 && boardsList.classList.contains('is-compact')) {
                // -290 here because width of boardsList is animating so therefore
                // getting the width here is incorrect
                // 290 is the width of the sidebar
                right -= boardsList.offsetWidth - 290;
              } else {
                right -= boardsList.offsetWidth;
              }

              if (right - boardsList.scrollLeft > 0) {
                $(boardsList).animate({
                  scrollLeft: right
                }, this.sortableOptions.animation);
              } else if (left > 0) {
                $(boardsList).animate({
                  scrollLeft: offsetLeft
                }, this.sortableOptions.animation);
              }
            }
          },

          deep: true
        }
      },
      methods: {
        showNewIssueForm: function showNewIssueForm() {
          this.$refs['board-list'].showIssueForm = !this.$refs['board-list'].showIssueForm;
        }
      },
      mounted: function mounted() {
        var _this = this;

        this.sortableOptions = gl.issueBoards.getBoardSortableDefaultOptions({
          disabled: this.disabled,
          group: 'boards',
          draggable: '.is-draggable',
          handle: '.js-board-handle',
          onEnd: function onEnd(e) {
            gl.issueBoards.onEnd();

            if (e.newIndex !== undefined && e.oldIndex !== e.newIndex) {
              var order = _this.sortable.toArray();
              var list = Store.findList('id', parseInt(e.item.dataset.id, 10));

              _this.$nextTick(function () {
                Store.moveList(list, order);
              });
            }
          }
        });

        this.sortable = Sortable.create(this.$el.parentNode, this.sortableOptions);
      }
    });
  })();
}).call(window);

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, space-before-function-paren, no-new */
  /* global Vue */
  /* global IssuableContext */
  /* global MilestoneSelect */
  /* global LabelsSelect */
  /* global Sidebar */

  __webpack_require__(260);

  (function () {
    var Store = gl.issueBoards.BoardsStore;

    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    gl.issueBoards.BoardSidebar = Vue.extend({
      props: {
        currentUser: Object
      },
      data: function data() {
        return {
          detail: Store.detail,
          issue: {},
          list: {}
        };
      },

      computed: {
        showSidebar: function showSidebar() {
          return Object.keys(this.issue).length;
        }
      },
      watch: {
        detail: {
          handler: function handler() {
            if (this.issue.id !== this.detail.issue.id) {
              $('.js-issue-board-sidebar', this.$el).each(function (i, el) {
                $(el).data('glDropdown').clearMenu();
              });
            }

            this.issue = this.detail.issue;
            this.list = this.detail.list;
          },

          deep: true
        },
        issue: function issue() {
          if (this.showSidebar) {
            this.$nextTick(function () {
              $('.right-sidebar').getNiceScroll(0).doScrollTop(0, 0);
              $('.right-sidebar').getNiceScroll().resize();
            });
          }
        }
      },
      methods: {
        closeSidebar: function closeSidebar() {
          this.detail.issue = {};
        }
      },
      mounted: function mounted() {
        new IssuableContext(this.currentUser);
        new MilestoneSelect();
        new gl.DueDateSelectors();
        new LabelsSelect();
        new Sidebar();
        gl.Subscription.bindAll('.subscription');
      },

      components: {
        removeBtn: gl.issueBoards.RemoveIssueBtn
      }
    });
  })();
}).call(window);

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  var Vue = __webpack_require__(0);
  var checkmarkIcon = __webpack_require__(261);

  var Store = gl.issueBoards.BoardsStore;
  var ModalStore = gl.issueBoards.ModalStore;

  module.exports = Vue.extend({
    mixins: [gl.issueBoards.ModalMixins],
    data: function data() {
      return ModalStore.store;
    },

    computed: {
      disabled: function disabled() {
        return !Store.state.lists.filter(function (list) {
          return list.type !== 'blank' && list.type !== 'done';
        }).length;
      }
    },
    template: '\n    <div class="boards-backlog-help text-center">\n      <h4>\n        We moved the Backlog\n        <button\n          type="button"\n          class="close"\n          aria-label="Close backlog help"\n          @click="toggleModal(false)">\n          <i\n            class="fa fa-times"\n            aria-hidden="true">\n          </i>\n        </button>\n      </h4>\n      <div class="backlog-help-icon">' + checkmarkIcon + '</div>\n      <p>\n        <a href="http://docs.gitlab.com/ce/user/project/issue_board.html">Read the docs</a> for more details\n      </p>\n      <p>\n        Populate the board using this button\n      </p>\n      <div class="text-center">\n        <button\n          class="btn btn-success"\n          type="button"\n          :disabled="disabled"\n          @click="toggleModal(true, false)">\n          Add issues\n        </button>\n      </div>\n    </div>\n  '
  });
}).call(window);

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Vue */
  /* global ListIssue */

  __webpack_require__(256);
  __webpack_require__(257);
  __webpack_require__(255);
  __webpack_require__(250);

  (function () {
    var ModalStore = gl.issueBoards.ModalStore;

    gl.issueBoards.IssuesModal = Vue.extend({
      props: {
        blankStateImage: {
          type: String,
          required: true
        },
        newIssuePath: {
          type: String,
          required: true
        },
        issueLinkBase: {
          type: String,
          required: true
        },
        rootPath: {
          type: String,
          required: true
        },
        projectId: {
          type: Number,
          required: true
        },
        milestonePath: {
          type: String,
          required: true
        },
        labelPath: {
          type: String,
          required: true
        }
      },
      data: function data() {
        return ModalStore.store;
      },

      watch: {
        page: function page() {
          this.loadIssues();
        },
        searchTerm: function searchTerm() {
          this.searchOperation();
        },
        showAddIssuesModal: function showAddIssuesModal() {
          var _this = this;

          if (this.showAddIssuesModal && !this.issues.length) {
            this.loading = true;

            this.loadIssues().then(function () {
              _this.loading = false;
            });
          } else if (!this.showAddIssuesModal) {
            this.issues = [];
            this.selectedIssues = [];
            this.issuesCount = false;
          }
        },

        filter: {
          handler: function handler() {
            this.loadIssues(true);
          },

          deep: true
        }
      },
      methods: {
        searchOperation: _.debounce(function searchOperationDebounce() {
          this.loadIssues(true);
        }, 500),
        loadIssues: function loadIssues() {
          var _this2 = this;

          var clearIssues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

          if (!this.showAddIssuesModal) return false;

          var queryData = Object.assign({}, this.filter, {
            search: this.searchTerm,
            page: this.page,
            per: this.perPage
          });

          return gl.boardService.getBacklog(queryData).then(function (res) {
            var data = res.json();

            if (clearIssues) {
              _this2.issues = [];
            }

            data.issues.forEach(function (issueObj) {
              var issue = new ListIssue(issueObj);
              var foundSelectedIssue = ModalStore.findSelectedIssue(issue);
              issue.selected = !!foundSelectedIssue;

              _this2.issues.push(issue);
            });

            _this2.loadingNewPage = false;

            if (!_this2.issuesCount) {
              _this2.issuesCount = data.size;
            }
          });
        }
      },
      computed: {
        showList: function showList() {
          if (this.activeTab === 'selected') {
            return this.selectedIssues.length > 0;
          }

          return this.issuesCount > 0;
        },
        showEmptyState: function showEmptyState() {
          if (!this.loading && this.issuesCount === 0) {
            return true;
          }

          return this.activeTab === 'selected' && this.selectedIssues.length === 0;
        }
      },
      components: {
        'modal-header': gl.issueBoards.ModalHeader,
        'modal-list': gl.issueBoards.ModalList,
        'modal-footer': gl.issueBoards.ModalFooter,
        'empty-state': gl.issueBoards.ModalEmptyState
      },
      template: '\n      <div\n        class="add-issues-modal"\n        v-if="showAddIssuesModal">\n        <div class="add-issues-container">\n          <modal-header\n            :project-id="projectId"\n            :milestone-path="milestonePath"\n            :label-path="labelPath">\n          </modal-header>\n          <modal-list\n            :image="blankStateImage"\n            :issue-link-base="issueLinkBase"\n            :root-path="rootPath"\n            v-if="!loading && showList"></modal-list>\n          <empty-state\n            v-if="showEmptyState"\n            :image="blankStateImage"\n            :new-issue-path="newIssuePath"></empty-state>\n          <section\n            class="add-issues-list text-center"\n            v-if="loading">\n            <div class="add-issues-list-loading">\n              <i class="fa fa-spinner fa-spin"></i>\n            </div>\n          </section>\n          <modal-footer></modal-footer>\n        </div>\n      </div>\n    '
    });
  })();
}).call(window);

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, func-names, no-new, space-before-function-paren, one-var */

  (function () {
    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    var Store = gl.issueBoards.BoardsStore;

    $(document).off('created.label').on('created.label', function (e, label) {
      Store.new({
        title: label.title,
        position: Store.state.lists.length - 2,
        list_type: 'label',
        label: {
          id: label.id,
          title: label.title,
          color: label.color
        }
      });
    });

    gl.issueBoards.newListDropdownInit = function () {
      $('.js-new-board-list').each(function () {
        var $this = $(this);
        new gl.CreateLabelDropdown($this.closest('.dropdown').find('.dropdown-new-label'), $this.data('namespace-path'), $this.data('project-path'));

        $this.glDropdown({
          data: function data(term, callback) {
            $.get($this.attr('data-labels')).then(function (resp) {
              callback(resp);
            });
          },
          renderRow: function renderRow(label) {
            var active = Store.findList('title', label.title);
            var $li = $('<li />');
            var $a = $('<a />', {
              class: active ? 'is-active js-board-list-' + active.id : '',
              text: label.title,
              href: '#'
            });
            var $labelColor = $('<span />', {
              class: 'dropdown-label-box',
              style: 'background-color: ' + label.color
            });

            return $li.append($a.prepend($labelColor));
          },

          search: {
            fields: ['title']
          },
          filterable: true,
          selectable: true,
          multiSelect: true,
          clicked: function clicked(label, $el, e) {
            e.preventDefault();

            if (!Store.findList('title', label.title)) {
              Store.new({
                title: label.title,
                position: Store.state.lists.length - 2,
                list_type: 'label',
                label: {
                  id: label.id,
                  title: label.title,
                  color: label.color
                }
              });

              Store.state.lists = _.sortBy(Store.state.lists, 'position');
            }
          }
        });
      });
    };
  })();
}).call(window);

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * vue-resource v0.9.3
 * https://github.com/vuejs/vue-resource
 * Released under the MIT License.
 */



/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$2(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$2.reject = function (r) {
    return new Promise$2(function (resolve, reject) {
        reject(r);
    });
};

Promise$2.resolve = function (x) {
    return new Promise$2(function (resolve, reject) {
        resolve(x);
    });
};

Promise$2.all = function all(iterable) {
    return new Promise$2(function (resolve, reject) {
        var count = 0,
            result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$2.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$2.race = function race(iterable) {
    return new Promise$2(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$2.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p$1 = Promise$2.prototype;

p$1.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;
                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p$1.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p$1.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p$1.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$2(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p$1.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

var PromiseObj = window.Promise || Promise$2;

function Promise$1(executor, context) {

    if (executor instanceof PromiseObj) {
        this.promise = executor;
    } else {
        this.promise = new PromiseObj(executor.bind(context));
    }

    this.context = context;
}

Promise$1.all = function (iterable, context) {
    return new Promise$1(PromiseObj.all(iterable), context);
};

Promise$1.resolve = function (value, context) {
    return new Promise$1(PromiseObj.resolve(value), context);
};

Promise$1.reject = function (reason, context) {
    return new Promise$1(PromiseObj.reject(reason), context);
};

Promise$1.race = function (iterable, context) {
    return new Promise$1(PromiseObj.race(iterable), context);
};

var p = Promise$1.prototype;

p.bind = function (context) {
    this.context = context;
    return this;
};

p.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new Promise$1(this.promise.then(fulfilled, rejected), this.context);
};

p.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new Promise$1(this.promise.catch(rejected), this.context);
};

p.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return PromiseObj.reject(reason);
    });
};

var debug = false;
var util = {};
var array = [];
function Util (Vue) {
    util = Vue.util;
    debug = Vue.config.debug || !Vue.config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return util.nextTick(cb, ctx);
}

function trim(str) {
    return str.replace(/^\s*|\s*$/g, '');
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isBoolean(val) {
    return val === true || val === false;
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = Promise$1.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({ $vm: obj, $options: opts }), fn, { $options: opts });
}

function each(obj, iterator) {

    var i, key;

    if (typeof obj.length == 'number') {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = array.slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = array.slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }
    });

    return target;
}

function _assign(target) {

    var args = array.slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

function root (options, next) {

    var url = next(options);

    if (isString(options.root) && !url.match(/^(https?:)?\//)) {
        url = options.root + '/' + url;
    }

    return url;
}

function query (options, next) {

    var urlParams = Object.keys(Url.options.params),
        query = {},
        url = next(options);

    each(options.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url),
        expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'],
        variables = [];

    return {
        vars: variables,
        expand: function (context) {
            return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null,
                        values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }
                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key],
        result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

function template (options) {

    var variables = [],
        url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

var ie = document.documentMode;
var el = document.createElement('a');

function Url(url, params) {

    var self = this || {},
        options = url,
        transform;

    if (isString(url)) {
        options = { url: url, params: params };
    }

    options = merge({}, Url.options, self.$options, options);

    Url.transforms.forEach(function (handler) {
        transform = factory(handler, transform, self.$vm);
    });

    return transform(options);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transforms = [template, query, root];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [],
        escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    if (ie) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options) {
        return handler.call(vm, options, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj),
        plain = isPlainObject(obj),
        hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

function xdrClient (request) {
    return new Promise$1(function (resolve) {

        var xdr = new XDomainRequest(),
            handler = function (event) {

            var response = request.respondWith(xdr.responseText, {
                status: xdr.status,
                statusText: xdr.statusText
            });

            resolve(response);
        };

        request.abort = function () {
            return xdr.abort();
        };

        xdr.open(request.method, request.getUrl(), true);
        xdr.timeout = 0;
        xdr.onload = handler;
        xdr.onerror = handler;
        xdr.ontimeout = function () {};
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

var ORIGIN_URL = Url.parse(location.href);
var SUPPORTS_CORS = 'withCredentials' in new XMLHttpRequest();

function cors (request, next) {

    if (!isBoolean(request.crossOrigin) && crossOrigin(request)) {
        request.crossOrigin = true;
    }

    if (request.crossOrigin) {

        if (!SUPPORTS_CORS) {
            request.client = xdrClient;
        }

        delete request.emulateHTTP;
    }

    next();
}

function crossOrigin(request) {

    var requestUrl = Url.parse(Url(request));

    return requestUrl.protocol !== ORIGIN_URL.protocol || requestUrl.host !== ORIGIN_URL.host;
}

function body (request, next) {

    if (request.emulateJSON && isPlainObject(request.body)) {
        request.body = Url.params(request.body);
        request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }

    if (isFormData(request.body)) {
        delete request.headers['Content-Type'];
    }

    if (isPlainObject(request.body)) {
        request.body = JSON.stringify(request.body);
    }

    next(function (response) {

        var contentType = response.headers['Content-Type'];

        if (isString(contentType) && contentType.indexOf('application/json') === 0) {

            try {
                response.data = response.json();
            } catch (e) {
                response.data = null;
            }
        } else {
            response.data = response.text();
        }
    });
}

function jsonpClient (request) {
    return new Promise$1(function (resolve) {

        var name = request.jsonp || 'callback',
            callback = '_jsonp' + Math.random().toString(36).substr(2),
            body = null,
            handler,
            script;

        handler = function (event) {

            var status = 0;

            if (event.type === 'load' && body !== null) {
                status = 200;
            } else if (event.type === 'error') {
                status = 404;
            }

            resolve(request.respondWith(body, { status: status }));

            delete window[callback];
            document.body.removeChild(script);
        };

        request.params[name] = callback;

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

function jsonp (request, next) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

    next(function (response) {

        if (request.method == 'JSONP') {
            response.data = response.json();
        }
    });
}

function before (request, next) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

    next();
}

/**
 * HTTP method override Interceptor.
 */

function method (request, next) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers['X-HTTP-Method-Override'] = request.method;
        request.method = 'POST';
    }

    next();
}

function header (request, next) {

    request.method = request.method.toUpperCase();
    request.headers = assign({}, Http.headers.common, !request.crossOrigin ? Http.headers.custom : {}, Http.headers[request.method.toLowerCase()], request.headers);

    next();
}

/**
 * Timeout Interceptor.
 */

function timeout (request, next) {

    var timeout;

    if (request.timeout) {
        timeout = setTimeout(function () {
            request.abort();
        }, request.timeout);
    }

    next(function (response) {

        clearTimeout(timeout);
    });
}

function xhrClient (request) {
    return new Promise$1(function (resolve) {

        var xhr = new XMLHttpRequest(),
            handler = function (event) {

            var response = request.respondWith('response' in xhr ? xhr.response : xhr.responseText, {
                status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText),
                headers: parseHeaders(xhr.getAllResponseHeaders())
            });

            resolve(response);
        };

        request.abort = function () {
            return xhr.abort();
        };

        xhr.open(request.method, request.getUrl(), true);
        xhr.timeout = 0;
        xhr.onload = handler;
        xhr.onerror = handler;

        if (request.progress) {
            if (request.method === 'GET') {
                xhr.addEventListener('progress', request.progress);
            } else if (/^(POST|PUT)$/i.test(request.method)) {
                xhr.upload.addEventListener('progress', request.progress);
            }
        }

        if (request.credentials === true) {
            xhr.withCredentials = true;
        }

        each(request.headers || {}, function (value, header) {
            xhr.setRequestHeader(header, value);
        });

        xhr.send(request.getBody());
    });
}

function parseHeaders(str) {

    var headers = {},
        value,
        name,
        i;

    each(trim(str).split('\n'), function (row) {

        i = row.indexOf(':');
        name = trim(row.slice(0, i));
        value = trim(row.slice(i + 1));

        if (headers[name]) {

            if (isArray(headers[name])) {
                headers[name].push(value);
            } else {
                headers[name] = [headers[name], value];
            }
        } else {

            headers[name] = value;
        }
    });

    return headers;
}

function Client (context) {

    var reqHandlers = [sendRequest],
        resHandlers = [],
        handler;

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        return new Promise$1(function (resolve) {

            function exec() {

                handler = reqHandlers.pop();

                if (isFunction(handler)) {
                    handler.call(context, request, next);
                } else {
                    warn('Invalid interceptor of type ' + typeof handler + ', must be a function');
                    next();
                }
            }

            function next(response) {

                if (isFunction(response)) {

                    resHandlers.unshift(response);
                } else if (isObject(response)) {

                    resHandlers.forEach(function (handler) {
                        response = when(response, function (response) {
                            return handler.call(context, response) || response;
                        });
                    });

                    when(response, resolve);

                    return;
                }

                exec();
            }

            exec();
        }, context);
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request, resolve) {

    var client = request.client || xhrClient;

    resolve(client(request));
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/**
 * HTTP Response.
 */

var Response = function () {
    function Response(body, _ref) {
        var url = _ref.url;
        var headers = _ref.headers;
        var status = _ref.status;
        var statusText = _ref.statusText;
        classCallCheck(this, Response);


        this.url = url;
        this.body = body;
        this.headers = headers || {};
        this.status = status || 0;
        this.statusText = statusText || '';
        this.ok = status >= 200 && status < 300;
    }

    Response.prototype.text = function text() {
        return this.body;
    };

    Response.prototype.blob = function blob() {
        return new Blob([this.body]);
    };

    Response.prototype.json = function json() {
        return JSON.parse(this.body);
    };

    return Response;
}();

var Request = function () {
    function Request(options) {
        classCallCheck(this, Request);


        this.method = 'GET';
        this.body = null;
        this.params = {};
        this.headers = {};

        assign(this, options);
    }

    Request.prototype.getUrl = function getUrl() {
        return Url(this);
    };

    Request.prototype.getBody = function getBody() {
        return this.body;
    };

    Request.prototype.respondWith = function respondWith(body, options) {
        return new Response(body, assign(options || {}, { url: this.getUrl() }));
    };

    return Request;
}();

/**
 * Service for sending network requests.
 */

var CUSTOM_HEADERS = { 'X-Requested-With': 'XMLHttpRequest' };
var COMMON_HEADERS = { 'Accept': 'application/json, text/plain, */*' };
var JSON_CONTENT_TYPE = { 'Content-Type': 'application/json;charset=utf-8' };

function Http(options) {

    var self = this || {},
        client = Client(self.$vm);

    defaults(options || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {
        client.use(handler);
    });

    return client(new Request(options)).then(function (response) {

        return response.ok ? response : Promise$1.reject(response);
    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return Promise$1.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    custom: CUSTOM_HEADERS,
    common: COMMON_HEADERS
};

Http.interceptors = [before, timeout, method, body, jsonp, header, cors];

['get', 'delete', 'head', 'jsonp'].forEach(function (method) {

    Http[method] = function (url, options) {
        return this(assign(options || {}, { url: url, method: method }));
    };
});

['post', 'put', 'patch'].forEach(function (method) {

    Http[method] = function (url, body, options) {
        return this(assign(options || {}, { url: url, method: method, body: body }));
    };
});

function Resource(url, params, actions, options) {

    var self = this || {},
        resource = {};

    actions = assign({}, Resource.actions, actions);

    each(actions, function (action, name) {

        action = merge({ url: url, params: params || {} }, options, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options = assign({}, action),
        params = {},
        body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 4 arguments [params, body], got ' + args.length + ' arguments';
    }

    options.body = body;
    options.params = assign({}, options.params, params);

    return options;
}

Resource.actions = {

    get: { method: 'GET' },
    save: { method: 'POST' },
    query: { method: 'GET' },
    update: { method: 'PUT' },
    remove: { method: 'DELETE' },
    delete: { method: 'DELETE' }

};

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = Promise$1;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function () {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function () {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function () {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function () {
                var _this = this;

                return function (executor) {
                    return new Vue.Promise(executor, _this);
                };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

module.exports = plugin;

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
(function() {

/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */

(function sortableModule(factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	}
	else if (typeof Package !== "undefined") {
		//noinspection JSUnresolvedVariable
		Sortable = factory();  // export for Meteor.js
	}
	else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function sortableFactory() {
	"use strict";

	if (typeof window == "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
		parentEl,
		ghostEl,
		cloneEl,
		rootEl,
		nextEl,

		scrollEl,
		scrollParentEl,
		scrollCustomFn,

		lastEl,
		lastCSS,
		lastParentCSS,

		oldIndex,
		newIndex,

		activeGroup,
		putSortable,

		autoScroll = {},

		tapEvt,
		touchEvt,

		moved,

		/** @const */
		RSPACE = /\s+/g,

		expando = 'Sortable' + (new Date).getTime(),

		win = window,
		document = win.document,
		parseInt = win.parseInt,

		$ = win.jQuery || win.Zepto,
		Polymer = win.Polymer,

		supportDraggable = !!('draggable' in document.createElement('div')),
		supportCssPointerEvents = (function (el) {
			// false when IE11
			if (!!navigator.userAgent.match(/Trident.*rv[ :]?11\./)) {
				return false;
			}
			el = document.createElement('x');
			el.style.cssText = 'pointer-events:auto';
			return el.style.pointerEvents === 'auto';
		})(),

		_silent = false,

		abs = Math.abs,
		min = Math.min,
		slice = [].slice,

		touchDragOverListeners = [],

		_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
			// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
			if (rootEl && options.scroll) {
				var el,
					rect,
					sens = options.scrollSensitivity,
					speed = options.scrollSpeed,

					x = evt.clientX,
					y = evt.clientY,

					winWidth = window.innerWidth,
					winHeight = window.innerHeight,

					vx,
					vy,

					scrollOffsetX,
					scrollOffsetY
				;

				// Delect scrollEl
				if (scrollParentEl !== rootEl) {
					scrollEl = options.scroll;
					scrollParentEl = rootEl;
					scrollCustomFn = options.scrollFn;

					if (scrollEl === true) {
						scrollEl = rootEl;

						do {
							if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
								(scrollEl.offsetHeight < scrollEl.scrollHeight)
							) {
								break;
							}
							/* jshint boss:true */
						} while (scrollEl = scrollEl.parentNode);
					}
				}

				if (scrollEl) {
					el = scrollEl;
					rect = scrollEl.getBoundingClientRect();
					vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
					vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
				}


				if (!(vx || vy)) {
					vx = (winWidth - x <= sens) - (x <= sens);
					vy = (winHeight - y <= sens) - (y <= sens);

					/* jshint expr:true */
					(vx || vy) && (el = win);
				}


				if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
					autoScroll.el = el;
					autoScroll.vx = vx;
					autoScroll.vy = vy;

					clearInterval(autoScroll.pid);

					if (el) {
						autoScroll.pid = setInterval(function () {
							scrollOffsetY = vy ? vy * speed : 0;
							scrollOffsetX = vx ? vx * speed : 0;

							if ('function' === typeof(scrollCustomFn)) {
								return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
							}

							if (el === win) {
								win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
							} else {
								el.scrollTop += scrollOffsetY;
								el.scrollLeft += scrollOffsetX;
							}
						}, 24);
					}
				}
			}
		}, 30),

		_prepareGroup = function (options) {
			function toFn(value, pull) {
				if (value === void 0 || value === true) {
					value = group.name;
				}

				if (typeof value === 'function') {
					return value;
				} else {
					return function (to, from) {
						var fromGroup = from.options.group.name;

						return pull
							? value
							: value && (value.join
								? value.indexOf(fromGroup) > -1
								: (fromGroup == value)
							);
					};
				}
			}

			var group = {};
			var originalGroup = options.group;

			if (!originalGroup || typeof originalGroup != 'object') {
				originalGroup = {name: originalGroup};
			}

			group.name = originalGroup.name;
			group.checkPull = toFn(originalGroup.pull, true);
			group.checkPut = toFn(originalGroup.put);

			options.group = group;
		}
	;



	/**
	 * @class  Sortable
	 * @param  {HTMLElement}  el
	 * @param  {Object}       [options]
	 */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);


		// Export instance
		el[expando] = this;


		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			animation: 0,
			setData: function (dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: {x: 0, y: 0}
		};


		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}


	Sortable.prototype = /** @lends Sortable.prototype */ {
		constructor: Sortable,

		_onTapStart: function (/** Event|TouchEvent */evt) {
			var _this = this,
				el = this.el,
				options = this.options,
				type = evt.type,
				touch = evt.touches && evt.touches[0],
				target = (touch || evt).target,
				originalTarget = evt.target.shadowRoot && evt.path[0] || target,
				filter = options.filter,
				startIndex;

			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (type === 'mousedown' && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}

			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}

			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, startIndex);
					evt.preventDefault();
					return; // cancel dnd
				}
			}
			else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, startIndex);
						return true;
					}
				});

				if (filter) {
					evt.preventDefault();
					return; // cancel dnd
				}
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex);
		},

		_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
			var _this = this,
				el = _this.el,
				options = _this.options,
				ownerDocument = el.ownerDocument,
				dragStartFn;

			if (target && !dragEl && (target.parentNode === el)) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				activeGroup = options.group;
				oldIndex = startIndex;

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'transform';

				dragStartFn = function () {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = _this.nativeDraggable;

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, oldIndex);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}
			}
		},

		_disableDelayedDrag: function () {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
		},

		_triggerDragStart: function (/** Touch */touch) {
			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			}
			else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			}
			else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					// Timeout neccessary for IE9
					setTimeout(function () {
						document.selection.empty();
					});
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {
			}
		},

		_dragStarted: function () {
			if (rootEl && dragEl) {
				var options = this.options;

				// Apply effect
				_toggleClass(dragEl, options.ghostClass, true);
				_toggleClass(dragEl, options.dragClass, false);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, oldIndex);
			}
		},

		_emulateDragOver: function () {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY),
					parent = target,
					i = touchDragOverListeners.length;

				if (parent) {
					do {
						if (parent[expando]) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},


		_onTouchMove: function (/**TouchEvent*/evt) {
			if (tapEvt) {
				var	options = this.options,
					fallbackTolerance = options.fallbackTolerance,
					fallbackOffset = options.fallbackOffset,
					touch = evt.touches ? evt.touches[0] : evt,
					dx = (touch.clientX - tapEvt.clientX) + fallbackOffset.x,
					dy = (touch.clientY - tapEvt.clientY) + fallbackOffset.y,
					translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					if (fallbackTolerance &&
						min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance
					) {
						return;
					}

					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function () {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
					css = _css(dragEl),
					options = this.options,
					ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
			var dataTransfer = evt.dataTransfer,
				options = this.options;

			this._offUpEvents();

			if (activeGroup.checkPull(this, this, dragEl, evt) == 'clone') {
				cloneEl = _clone(dragEl);
				_css(cloneEl, 'display', 'none');
				rootEl.insertBefore(cloneEl, dragEl);
				_dispatchEvent(this, rootEl, 'clone', dragEl);
			}

			_toggleClass(dragEl, options.dragClass, true);

			if (useFallback) {
				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', this._onTouchMove);
					_on(document, 'touchend', this._onDrop);
					_on(document, 'touchcancel', this._onDrop);
				} else {
					// Old brwoser
					_on(document, 'mousemove', this._onTouchMove);
					_on(document, 'mouseup', this._onDrop);
				}

				this._loopId = setInterval(this._emulateDragOver, 50);
			}
			else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(this, dataTransfer, dragEl);
				}

				_on(document, 'drop', this);
				setTimeout(this._dragStarted, 0);
			}
		},

		_onDragOver: function (/**Event*/evt) {
			var el = this.el,
				target,
				dragRect,
				targetRect,
				revert,
				options = this.options,
				group = options.group,
				activeSortable = Sortable.active,
				isOwner = (activeGroup === group),
				canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				!options.dragoverBubble && evt.stopPropagation();
			}

			moved = true;

			if (activeGroup && !options.disabled &&
				(isOwner
					? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
					: (
						putSortable === this ||
						activeGroup.checkPull(this, activeSortable, dragEl, evt) && group.checkPut(this, activeSortable, dragEl, evt)
					)
				) &&
				(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
				// Smart auto-scrolling
				_autoScroll(evt, options, this.el);

				if (_silent) {
					return;
				}

				target = _closest(evt.target, options.draggable, el);
				dragRect = dragEl.getBoundingClientRect();
				putSortable = this;

				if (revert) {
					_cloneHide(true);
					parentEl = rootEl; // actualization

					if (cloneEl || nextEl) {
						rootEl.insertBefore(dragEl, cloneEl || nextEl);
					}
					else if (!canSort) {
						rootEl.appendChild(dragEl);
					}

					return;
				}


				if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
					(el === evt.target) && (target = _ghostIsLast(el, evt))
				) {
					if (target) {
						if (target.animated) {
							return;
						}

						targetRect = target.getBoundingClientRect();
					}

					_cloneHide(isOwner);

					if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
						if (!dragEl.contains(el)) {
							el.appendChild(dragEl);
							parentEl = el; // actualization
						}

						this._animate(dragRect, dragEl);
						target && this._animate(targetRect, target);
					}
				}
				else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
					if (lastEl !== target) {
						lastEl = target;
						lastCSS = _css(target);
						lastParentCSS = _css(target.parentNode);
					}

					targetRect = target.getBoundingClientRect();

					var width = targetRect.right - targetRect.left,
						height = targetRect.bottom - targetRect.top,
						floating = /left|right|inline/.test(lastCSS.cssFloat + lastCSS.display)
							|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
						isWide = (target.offsetWidth > dragEl.offsetWidth),
						isLong = (target.offsetHeight > dragEl.offsetHeight),
						halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						nextSibling = target.nextElementSibling,
						moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt),
						after
					;

					if (moveVector !== false) {
						_silent = true;
						setTimeout(_unsilent, 30);

						_cloneHide(isOwner);

						if (moveVector === 1 || moveVector === -1) {
							after = (moveVector === 1);
						}
						else if (floating) {
							var elTop = dragEl.offsetTop,
								tgTop = target.offsetTop;

							if (elTop === tgTop) {
								after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
							}
							else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
								after = (evt.clientY - targetRect.top) / height > 0.5;
							} else {
								after = tgTop > elTop;
							}
						} else {
							after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
						}

						if (!dragEl.contains(el)) {
							if (after && !nextSibling) {
								el.appendChild(dragEl);
							} else {
								target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
							}
						}

						parentEl = dragEl.parentNode; // actualization

						this._animate(dragRect, dragEl);
						this._animate(targetRect, target);
					}
				}
			}
		},

		_animate: function (prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d('
					+ (prevRect.left - currentRect.left) + 'px,'
					+ (prevRect.top - currentRect.top) + 'px,0)'
				);

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function () {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
		},

		_onDrop: function (/**Event*/evt) {
			var el = this.el,
				options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			// Unbind events
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode.removeChild(ghostEl);

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {

							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, rootEl, oldIndex, newIndex);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
						}
					}
					else {
						// Remove clone
						cloneEl && cloneEl.parentNode.removeChild(cloneEl);

						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}

			}

			this._nulling();
		},

		_nulling: function() {
			rootEl =
			dragEl =
			parentEl =
			ghostEl =
			nextEl =
			cloneEl =

			scrollEl =
			scrollParentEl =

			tapEvt =
			touchEvt =

			moved =
			newIndex =

			lastEl =
			lastCSS =

			putSortable =
			activeGroup =
			Sortable.active = null;
		},

		handleEvent: function (/**Event*/evt) {
			var type = evt.type;

			if (type === 'dragover' || type === 'dragenter') {
				if (dragEl) {
					this._onDragOver(evt);
					_globalDragOver(evt);
				}
			}
			else if (type === 'drop' || type === 'dragend') {
				this._onDrop(evt);
			}
		},


		/**
		 * Serializes the item into an array of string.
		 * @returns {String[]}
		 */
		toArray: function () {
			var order = [],
				el,
				children = this.el.children,
				i = 0,
				n = children.length,
				options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},


		/**
		 * Sorts the elements according to the array.
		 * @param  {String[]}  order  order of the items
		 */
		sort: function (order) {
			var items = {}, rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},


		/**
		 * Save the current sorting
		 */
		save: function () {
			var store = this.options.store;
			store && store.set(this);
		},


		/**
		 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
		 * @param   {HTMLElement}  el
		 * @param   {String}       [selector]  default: `options.draggable`
		 * @returns {HTMLElement|null}
		 */
		closest: function (el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},


		/**
		 * Set/get option
		 * @param   {string} name
		 * @param   {*}      [value]
		 * @returns {*}
		 */
		option: function (name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},


		/**
		 * Destroy
		 */
		destroy: function () {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};


	function _cloneHide(state) {
		if (cloneEl && (cloneEl.state !== state)) {
			_css(cloneEl, 'display', state ? 'none' : '');
			!state && cloneEl.state && rootEl.insertBefore(cloneEl, dragEl);
			cloneEl.state = state;
		}
	}


	function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;

			do {
				if ((selector === '>*' && el.parentNode === ctx) || _matches(el, selector)) {
					return el;
				}
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}


	function _getParentOrHost(el) {
		var parent = el.host;

		return (parent && parent.nodeType) ? parent : el.parentNode;
	}


	function _globalDragOver(/**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}


	function _on(el, event, fn) {
		el.addEventListener(event, fn, false);
	}


	function _off(el, event, fn) {
		el.removeEventListener(event, fn, false);
	}


	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			}
			else {
				var className = (' ' + el.className + ' ').replace(RSPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(RSPACE, ' ');
			}
		}
	}


	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				}
				else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			}
			else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}


	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}



	function _dispatchEvent(sortable, rootEl, name, targetEl, fromEl, startIndex, newIndex) {
		sortable = (sortable || rootEl[expando]);

		var evt = document.createEvent('Event'),
			options = sortable.options,
			onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}


	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt) {
		var evt,
			sortable = fromEl[expando],
			onMoveFn = sortable.options.onMove,
			retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}


	function _disableDraggable(el) {
		el.draggable = false;
	}


	function _unsilent() {
		_silent = false;
	}


	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
			rect = lastEl.getBoundingClientRect();

		// 5 — min delta
		// abs — нельзя добавлять, а то глюки при наведении сверху
		return (
			(evt.clientY - (rect.top + rect.height) > 5) ||
			(evt.clientX - (rect.right + rect.width) > 5)
		) && lastEl;
	}


	/**
	 * Generate id
	 * @param   {HTMLElement} el
	 * @returns {String}
	 * @private
	 */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
			i = str.length,
			sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
	 * Returns the index of an element within its parent for a selected set of
	 * elements
	 * @param  {HTMLElement} el
	 * @param  {selector} selector
	 * @return {number}
	 */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches(/**HTMLElement*/el, /**String*/selector) {
		if (el) {
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
				re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			return (
				(tag === '' || el.nodeName.toUpperCase() == tag) &&
				(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
			);
		}

		return false;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		return $
			? $(el).clone(true)[0]
			: (Polymer && Polymer.dom
				? Polymer.dom(el).cloneNode(true)
				: el.cloneNode(true)
			);
	}


	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function (el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index
	};


	/**
	 * Create sortable instance
	 * @param {HTMLElement}  el
	 * @param {Object}      [options]
	 */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};


	// Export
	Sortable.version = '1.4.2';
	return Sortable;
});

}.call(window));

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable space-before-function-paren, comma-dangle */
  /* global Vue */
  /* global ListLabel */

  (function () {
    var Store = gl.issueBoards.BoardsStore;

    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    gl.issueBoards.BoardBlankState = Vue.extend({
      data: function data() {
        return {
          predefinedLabels: [new ListLabel({ title: 'To Do', color: '#F0AD4E' }), new ListLabel({ title: 'Doing', color: '#5CB85C' })]
        };
      },

      methods: {
        addDefaultLists: function addDefaultLists() {
          this.clearBlankState();

          this.predefinedLabels.forEach(function (label, i) {
            Store.addList({
              title: label.title,
              position: i,
              list_type: 'label',
              label: {
                title: label.title,
                color: label.color
              }
            });
          });

          Store.state.lists = _.sortBy(Store.state.lists, 'position');

          // Save the labels
          gl.boardService.generateDefaultLists().then(function (resp) {
            resp.json().forEach(function (listObj) {
              var list = Store.findList('title', listObj.title);

              list.id = listObj.id;
              list.label.id = listObj.label.id;
              list.getIssues();
            });
          });
        },

        clearBlankState: Store.removeBlankState.bind(Store)
      }
    });
  })();
}).call(window);

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, space-before-function-paren, dot-notation */
  /* global Vue */

  __webpack_require__(249);

  (function () {
    var Store = gl.issueBoards.BoardsStore;

    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    gl.issueBoards.BoardCard = Vue.extend({
      template: '#js-board-list-card',
      components: {
        'issue-card-inner': gl.issueBoards.IssueCardInner
      },
      props: {
        list: Object,
        issue: Object,
        issueLinkBase: String,
        disabled: Boolean,
        index: Number,
        rootPath: String
      },
      data: function data() {
        return {
          showDetail: false,
          detailIssue: Store.detail
        };
      },

      computed: {
        issueDetailVisible: function issueDetailVisible() {
          return this.detailIssue.issue && this.detailIssue.issue.id === this.issue.id;
        }
      },
      methods: {
        mouseDown: function mouseDown() {
          this.showDetail = true;
        },
        mouseMove: function mouseMove() {
          this.showDetail = false;
        },
        showIssue: function showIssue(e) {
          var targetTagName = e.target.tagName.toLowerCase();

          if (targetTagName === 'a' || targetTagName === 'button') return;

          if (this.showDetail) {
            this.showDetail = false;

            if (Store.detail.issue && Store.detail.issue.id === this.issue.id) {
              Store.detail.issue = {};
            } else {
              Store.detail.issue = this.issue;
              Store.detail.list = this.list;
            }
          }
        }
      }
    });
  })();
}).call(window);

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, space-before-function-paren, no-alert */
  /* global Vue */

  (function () {
    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    gl.issueBoards.BoardDelete = Vue.extend({
      props: {
        list: Object
      },
      methods: {
        deleteBoard: function deleteBoard() {
          $(this.$el).tooltip('hide');

          if (confirm('Are you sure you want to delete this list?')) {
            this.list.destroy();
          }
        }
      }
    });
  })();
}).call(window);

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, space-before-function-paren, max-len */
  /* global Vue */
  /* global Sortable */

  __webpack_require__(245);
  __webpack_require__(248);

  (function () {
    var Store = gl.issueBoards.BoardsStore;

    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    gl.issueBoards.BoardList = Vue.extend({
      template: '#js-board-list-template',
      components: {
        'board-card': gl.issueBoards.BoardCard,
        'board-new-issue': gl.issueBoards.BoardNewIssue
      },
      props: {
        disabled: Boolean,
        list: Object,
        issues: Array,
        loading: Boolean,
        issueLinkBase: String,
        rootPath: String
      },
      data: function data() {
        return {
          scrollOffset: 250,
          filters: Store.state.filters,
          showCount: false,
          showIssueForm: false
        };
      },

      watch: {
        filters: {
          handler: function handler() {
            this.list.loadingMore = false;
            this.$refs.list.scrollTop = 0;
          },

          deep: true
        },
        issues: function issues() {
          var _this = this;

          this.$nextTick(function () {
            if (_this.scrollHeight() <= _this.listHeight() && _this.list.issuesSize > _this.list.issues.length) {
              _this.list.page += 1;
              _this.list.getIssues(false);
            }

            if (_this.scrollHeight() > _this.listHeight()) {
              _this.showCount = true;
            } else {
              _this.showCount = false;
            }
          });
        }
      },
      computed: {
        orderedIssues: function orderedIssues() {
          return _.sortBy(this.issues, 'priority');
        }
      },
      methods: {
        listHeight: function listHeight() {
          return this.$refs.list.getBoundingClientRect().height;
        },
        scrollHeight: function scrollHeight() {
          return this.$refs.list.scrollHeight;
        },
        scrollTop: function scrollTop() {
          return this.$refs.list.scrollTop + this.listHeight();
        },
        loadNextPage: function loadNextPage() {
          var _this2 = this;

          var getIssues = this.list.nextPage();

          if (getIssues) {
            this.list.loadingMore = true;
            getIssues.then(function () {
              _this2.list.loadingMore = false;
            });
          }
        }
      },
      mounted: function mounted() {
        var _this3 = this;

        var options = gl.issueBoards.getBoardSortableDefaultOptions({
          scroll: document.querySelectorAll('.boards-list')[0],
          group: 'issues',
          sort: false,
          disabled: this.disabled,
          filter: '.board-list-count, .is-disabled',
          onStart: function onStart(e) {
            var card = _this3.$refs.issue[e.oldIndex];

            card.showDetail = false;
            Store.moving.list = card.list;
            Store.moving.issue = Store.moving.list.findIssue(+e.item.dataset.issueId);

            gl.issueBoards.onStart();
          },
          onAdd: function onAdd(e) {
            gl.issueBoards.BoardsStore.moveIssueToList(Store.moving.list, _this3.list, Store.moving.issue, e.newIndex);

            _this3.$nextTick(function () {
              e.item.remove();
            });
          }
        });

        this.sortable = Sortable.create(this.$refs.list, options);

        // Scroll event on list to load more
        this.$refs.list.onscroll = function () {
          if (_this3.scrollTop() > _this3.scrollHeight() - _this3.scrollOffset && !_this3.list.loadingMore) {
            _this3.loadNextPage();
          }
        };
      }
    });
  })();
}).call(window);

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, no-unused-vars */
  /* global Vue */
  /* global ListIssue */

  (function () {
    var Store = gl.issueBoards.BoardsStore;

    window.gl = window.gl || {};

    gl.issueBoards.BoardNewIssue = Vue.extend({
      props: {
        list: Object
      },
      data: function data() {
        return {
          title: '',
          error: false
        };
      },

      methods: {
        submit: function submit(e) {
          var _this = this;

          e.preventDefault();
          if (this.title.trim() === '') return;

          this.error = false;

          var labels = this.list.label ? [this.list.label] : [];
          var issue = new ListIssue({
            title: this.title,
            labels: labels,
            subscribed: true
          });

          this.list.newIssue(issue).then(function (data) {
            // Need this because our jQuery very kindly disables buttons on ALL form submissions
            $(_this.$refs.submitButton).enable();

            Store.detail.issue = issue;
            Store.detail.list = _this.list;
          }).catch(function () {
            // Need this because our jQuery very kindly disables buttons on ALL form submissions
            $(_this.$refs.submitButton).enable();

            // Remove the issue
            _this.list.removeIssue(issue);

            // Show error message
            _this.error = true;
          });

          this.cancel();
        },
        cancel: function cancel() {
          this.title = '';
          this.$parent.showIssueForm = false;
        }
      },
      mounted: function mounted() {
        this.$refs.input.focus();
      }
    });
  })();
}).call(window);

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Vue */
  (function () {
    var Store = gl.issueBoards.BoardsStore;

    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    gl.issueBoards.IssueCardInner = Vue.extend({
      props: {
        issue: {
          type: Object,
          required: true
        },
        issueLinkBase: {
          type: String,
          required: true
        },
        list: {
          type: Object,
          required: false
        },
        rootPath: {
          type: String,
          required: true
        }
      },
      methods: {
        showLabel: function showLabel(label) {
          if (!this.list) return true;

          return !this.list.label || label.id !== this.list.label.id;
        },
        filterByLabel: function filterByLabel(label, e) {
          var labelToggleText = label.title;
          var labelIndex = Store.state.filters.label_name.indexOf(label.title);
          $(e.currentTarget).tooltip('hide');

          if (labelIndex === -1) {
            Store.state.filters.label_name.push(label.title);
            $('.labels-filter').prepend('<input type="hidden" name="label_name[]" value="' + label.title + '" />');
          } else {
            Store.state.filters.label_name.splice(labelIndex, 1);
            labelToggleText = Store.state.filters.label_name[0];
            $('.labels-filter input[name="label_name[]"][value="' + label.title + '"]').remove();
          }

          var selectedLabels = Store.state.filters.label_name;
          if (selectedLabels.length === 0) {
            labelToggleText = 'Label';
          } else if (selectedLabels.length > 1) {
            labelToggleText = selectedLabels[0] + ' + ' + (selectedLabels.length - 1) + ' more';
          }

          $('.labels-filter .dropdown-toggle-text').text(labelToggleText);

          Store.updateFiltersUrl();
        },
        labelStyle: function labelStyle(label) {
          return {
            backgroundColor: label.color,
            color: label.textColor
          };
        }
      },
      template: '\n      <div>\n        <h4 class="card-title">\n          <i\n            class="fa fa-eye-slash confidential-icon"\n            v-if="issue.confidential"></i>\n          <a\n            :href="issueLinkBase + \'/\' + issue.id"\n            :title="issue.title">\n            {{ issue.title }}\n          </a>\n        </h4>\n        <div class="card-footer">\n          <span\n            class="card-number"\n            v-if="issue.id">\n            #{{ issue.id }}\n          </span>\n          <a\n            class="card-assignee has-tooltip"\n            :href="rootPath + issue.assignee.username"\n            :title="\'Assigned to \' + issue.assignee.name"\n            v-if="issue.assignee"\n            data-container="body">\n            <img\n              class="avatar avatar-inline s20"\n              :src="issue.assignee.avatar"\n              width="20"\n              height="20"\n              :alt="\'Avatar for \' + issue.assignee.name" />\n          </a>\n          <button\n            class="label color-label has-tooltip"\n            v-for="label in issue.labels"\n            type="button"\n            v-if="showLabel(label)"\n            @click="filterByLabel(label, $event)"\n            :style="labelStyle(label)"\n            :title="label.description"\n            data-container="body">\n            {{ label.title }}\n          </button>\n        </div>\n      </div>\n    '
    });
  })();
}).call(window);

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Vue */
  (function () {
    var ModalStore = gl.issueBoards.ModalStore;

    gl.issueBoards.ModalEmptyState = Vue.extend({
      mixins: [gl.issueBoards.ModalMixins],
      data: function data() {
        return ModalStore.store;
      },

      props: {
        image: {
          type: String,
          required: true
        },
        newIssuePath: {
          type: String,
          required: true
        }
      },
      computed: {
        contents: function contents() {
          var obj = {
            title: 'You haven\'t added any issues to your project yet',
            content: '\n            An issue can be a bug, a todo or a feature request that needs to be\n            discussed in a project. Besides, issues are searchable and filterable.\n          '
          };

          if (this.activeTab === 'selected') {
            obj.title = 'You haven\'t selected any issues yet';
            obj.content = '\n            Go back to <strong>All issues</strong> and select some issues\n            to add to your board.\n          ';
          }

          return obj;
        }
      },
      template: '\n      <section class="empty-state">\n        <div class="row">\n          <div class="col-xs-12 col-sm-6 col-sm-push-6">\n            <aside class="svg-content" v-html="image"></aside>\n          </div>\n          <div class="col-xs-12 col-sm-6 col-sm-pull-6">\n            <div class="text-content">\n              <h4>{{ contents.title }}</h4>\n              <p v-html="contents.content"></p>\n              <a\n                :href="newIssuePath"\n                class="btn btn-success btn-inverted"\n                v-if="activeTab === \'all\'">\n                New issue\n              </a>\n              <button\n                type="button"\n                class="btn btn-default"\n                @click="changeTab(\'all\')"\n                v-if="activeTab === \'selected\'">\n                All issues\n              </button>\n            </div>\n          </div>\n        </div>\n      </section>\n    '
    });
  })();
}).call(window);

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Vue */
  var userFilter = __webpack_require__(254);
  var milestoneFilter = __webpack_require__(253);
  var labelFilter = __webpack_require__(252);

  module.exports = Vue.extend({
    name: 'modal-filters',
    props: {
      projectId: {
        type: Number,
        required: true
      },
      milestonePath: {
        type: String,
        required: true
      },
      labelPath: {
        type: String,
        required: true
      }
    },
    destroyed: function destroyed() {
      gl.issueBoards.ModalStore.setDefaultFilter();
    },

    components: {
      userFilter: userFilter,
      milestoneFilter: milestoneFilter,
      labelFilter: labelFilter
    },
    template: '\n    <div class="modal-filters">\n      <user-filter\n        dropdown-class-name="dropdown-menu-author"\n        toggle-class-name="js-user-search js-author-search"\n        toggle-label="Author"\n        field-name="author_id"\n        :project-id="projectId"></user-filter>\n      <user-filter\n        dropdown-class-name="dropdown-menu-author"\n        toggle-class-name="js-assignee-search"\n        toggle-label="Assignee"\n        field-name="assignee_id"\n        :null-user="true"\n        :project-id="projectId"></user-filter>\n      <milestone-filter :milestone-path="milestonePath"></milestone-filter>\n      <label-filter :label-path="labelPath"></label-filter>\n    </div>\n  '
  });
}).call(window);

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-new */
  /* global Vue */
  /* global LabelsSelect */
  module.exports = Vue.extend({
    name: 'filter-label',
    props: {
      labelPath: {
        type: String,
        required: true
      }
    },
    mounted: function mounted() {
      new LabelsSelect(this.$refs.dropdown);
    },

    template: '\n    <div class="dropdown">\n      <button\n        class="dropdown-menu-toggle js-label-select js-multiselect js-extra-options"\n        type="button"\n        data-toggle="dropdown"\n        data-show-any="true"\n        data-show-no="true"\n        :data-labels="labelPath"\n        ref="dropdown">\n        <span class="dropdown-toggle-text">\n          Label\n        </span>\n        <i class="fa fa-chevron-down"></i>\n      </button>\n      <div class="dropdown-menu dropdown-select dropdown-menu-paging dropdown-menu-labels dropdown-menu-selectable">\n        <div class="dropdown-title">\n          Filter by label\n          <button\n            class="dropdown-title-button dropdown-menu-close"\n            aria-label="Close"\n            type="button">\n            <i class="fa fa-times dropdown-menu-close-icon"></i>\n          </button>\n        </div>\n        <div class="dropdown-input">\n          <input\n            type="search"\n            class="dropdown-input-field"\n            placeholder="Search"\n            autocomplete="off" />\n          <i class="fa fa-search dropdown-input-search"></i>\n          <i role="button" class="fa fa-times dropdown-input-clear js-dropdown-input-clear"></i>\n        </div>\n        <div class="dropdown-content"></div>\n        <div class="dropdown-loading"><i class="fa fa-spinner fa-spin"></i></div>\n      </div>\n    </div>\n  '
  });
}).call(window);

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-new */
  /* global Vue */
  /* global MilestoneSelect */
  module.exports = Vue.extend({
    name: 'filter-milestone',
    props: {
      milestonePath: {
        type: String,
        required: true
      }
    },
    mounted: function mounted() {
      new MilestoneSelect(null, this.$refs.dropdown);
    },

    template: '\n    <div class="dropdown">\n      <button\n        class="dropdown-menu-toggle js-milestone-select"\n        type="button"\n        data-toggle="dropdown"\n        data-show-any="true"\n        data-show-upcoming="true"\n        data-field-name="milestone_title"\n        :data-milestones="milestonePath"\n        ref="dropdown">\n        <span class="dropdown-toggle-text">\n          Milestone\n        </span>\n        <i class="fa fa-chevron-down"></i>\n      </button>\n      <div class="dropdown-menu dropdown-select dropdown-menu-selectable dropdown-menu-milestone">\n        <div class="dropdown-title">\n          <span>Filter by milestone</span>\n          <button\n            class="dropdown-title-button dropdown-menu-close"\n            aria-label="Close"\n            type="button">\n            <i class="fa fa-times dropdown-menu-close-icon"></i>\n          </button>\n        </div>\n        <div class="dropdown-input">\n          <input\n            type="search"\n            class="dropdown-input-field"\n            placeholder="Search milestones"\n            autocomplete="off" />\n          <i class="fa fa-search dropdown-input-search"></i>\n          <i role="button" class="fa fa-times dropdown-input-clear js-dropdown-input-clear"></i>\n        </div>\n        <div class="dropdown-content"></div>\n        <div class="dropdown-loading"><i class="fa fa-spinner fa-spin"></i></div>\n      </div>\n    </div>\n  '
  });
}).call(window);

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-new */
  /* global Vue */
  /* global UsersSelect */
  module.exports = Vue.extend({
    name: 'filter-user',
    props: {
      toggleClassName: {
        type: String,
        required: true
      },
      dropdownClassName: {
        type: String,
        required: false,
        default: ''
      },
      toggleLabel: {
        type: String,
        required: true
      },
      fieldName: {
        type: String,
        required: true
      },
      nullUser: {
        type: Boolean,
        required: false,
        default: false
      },
      projectId: {
        type: Number,
        required: true
      }
    },
    mounted: function mounted() {
      new UsersSelect(null, this.$refs.dropdown);
    },

    computed: {
      currentUsername: function currentUsername() {
        return gon.current_username;
      },
      dropdownTitle: function dropdownTitle() {
        return 'Filter by ' + this.toggleLabel.toLowerCase();
      },
      inputPlaceholder: function inputPlaceholder() {
        return 'Search ' + this.toggleLabel.toLowerCase();
      }
    },
    template: '\n    <div class="dropdown">\n      <button\n        class="dropdown-menu-toggle js-user-search"\n        :class="toggleClassName"\n        type="button"\n        data-toggle="dropdown"\n        data-current-user="true"\n        :data-any-user="\'Any \' + toggleLabel"\n        :data-null-user="nullUser"\n        :data-field-name="fieldName"\n        :data-project-id="projectId"\n        :data-first-user="currentUsername"\n        ref="dropdown">\n        <span class="dropdown-toggle-text">\n          {{ toggleLabel }}\n        </span>\n        <i class="fa fa-chevron-down"></i>\n      </button>\n      <div\n        class="dropdown-menu dropdown-select dropdown-menu-user dropdown-menu-selectable"\n        :class="dropdownClassName">\n        <div class="dropdown-title">\n          {{ dropdownTitle }}\n          <button\n            class="dropdown-title-button dropdown-menu-close"\n            aria-label="Close"\n            type="button">\n            <i class="fa fa-times dropdown-menu-close-icon"></i>\n          </button>\n        </div>\n        <div class="dropdown-input">\n          <input\n            type="search"\n            class="dropdown-input-field"\n            autocomplete="off"\n            :placeholder="inputPlaceholder" />\n          <i class="fa fa-search dropdown-input-search"></i>\n          <i\n            role="button"\n            class="fa fa-times dropdown-input-clear js-dropdown-input-clear">\n          </i>\n        </div>\n        <div class="dropdown-content"></div>\n        <div class="dropdown-loading"><i class="fa fa-spinner fa-spin"></i></div>\n      </div>\n    </div>\n  '
  });
}).call(window);

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-new */
  /* global Vue */
  /* global Flash */

  __webpack_require__(258);

  (function () {
    var ModalStore = gl.issueBoards.ModalStore;

    gl.issueBoards.ModalFooter = Vue.extend({
      mixins: [gl.issueBoards.ModalMixins],
      data: function data() {
        return {
          modal: ModalStore.store,
          state: gl.issueBoards.BoardsStore.state
        };
      },

      computed: {
        submitDisabled: function submitDisabled() {
          return !ModalStore.selectedCount();
        },
        submitText: function submitText() {
          var count = ModalStore.selectedCount();

          return 'Add ' + (count > 0 ? count : '') + ' ' + gl.text.pluralize('issue', count);
        }
      },
      methods: {
        addIssues: function addIssues() {
          var list = this.modal.selectedList || this.state.lists[0];
          var selectedIssues = ModalStore.getSelectedIssues();
          var issueIds = selectedIssues.map(function (issue) {
            return issue.globalId;
          });

          // Post the data to the backend
          gl.boardService.bulkUpdate(issueIds, {
            add_label_ids: [list.label.id]
          }).catch(function () {
            new Flash('Failed to update issues, please try again.', 'alert');

            selectedIssues.forEach(function (issue) {
              list.removeIssue(issue);
              list.issuesSize -= 1;
            });
          });

          // Add the issues on the frontend
          selectedIssues.forEach(function (issue) {
            list.addIssue(issue);
            list.issuesSize += 1;
          });

          this.toggleModal(false);
        }
      },
      components: {
        'lists-dropdown': gl.issueBoards.ModalFooterListsDropdown
      },
      template: '\n      <footer\n        class="form-actions add-issues-footer">\n        <div class="pull-left">\n          <button\n            class="btn btn-success"\n            type="button"\n            :disabled="submitDisabled"\n            @click="addIssues">\n            {{ submitText }}\n          </button>\n          <span class="inline add-issues-footer-to-list">\n            to list\n          </span>\n          <lists-dropdown></lists-dropdown>\n        </div>\n        <button\n          class="btn btn-default pull-right"\n          type="button"\n          @click="toggleModal(false, false)">\n          Cancel\n        </button>\n      </footer>\n    '
    });
  })();
}).call(window);

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Vue */
  __webpack_require__(259);
  var modalFilters = __webpack_require__(251);

  (function () {
    var ModalStore = gl.issueBoards.ModalStore;

    gl.issueBoards.ModalHeader = Vue.extend({
      mixins: [gl.issueBoards.ModalMixins],
      props: {
        projectId: {
          type: Number,
          required: true
        },
        milestonePath: {
          type: String,
          required: true
        },
        labelPath: {
          type: String,
          required: true
        }
      },
      data: function data() {
        return ModalStore.store;
      },

      computed: {
        selectAllText: function selectAllText() {
          if (ModalStore.selectedCount() !== this.issues.length || this.issues.length === 0) {
            return 'Select all';
          }

          return 'Deselect all';
        },
        showSearch: function showSearch() {
          return this.activeTab === 'all' && !this.loading && this.issuesCount > 0;
        }
      },
      methods: {
        toggleAll: function toggleAll() {
          this.$refs.selectAllBtn.blur();

          ModalStore.toggleAll();
        }
      },
      components: {
        'modal-tabs': gl.issueBoards.ModalTabs,
        modalFilters: modalFilters
      },
      template: '\n      <div>\n        <header class="add-issues-header form-actions">\n          <h2>\n            Add issues\n            <button\n              type="button"\n              class="close"\n              data-dismiss="modal"\n              aria-label="Close"\n              @click="toggleModal(false, false)">\n              <span aria-hidden="true">\xD7</span>\n            </button>\n          </h2>\n        </header>\n        <modal-tabs v-if="!loading && issuesCount > 0"></modal-tabs>\n        <div\n          class="add-issues-search append-bottom-10"\n          v-if="showSearch">\n          <modal-filters\n            :project-id="projectId"\n            :milestone-path="milestonePath"\n            :label-path="labelPath">\n          </modal-filters>\n          <input\n            placeholder="Search issues..."\n            class="form-control"\n            type="search"\n            v-model="searchTerm" />\n          <button\n            type="button"\n            class="btn btn-success btn-inverted prepend-left-10"\n            ref="selectAllBtn"\n            @click="toggleAll">\n            {{ selectAllText }}\n          </button>\n        </div>\n      </div>\n    '
    });
  })();
}).call(window);

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Vue */
  /* global ListIssue */
  /* global bp */
  (function () {
    var ModalStore = gl.issueBoards.ModalStore;

    gl.issueBoards.ModalList = Vue.extend({
      props: {
        issueLinkBase: {
          type: String,
          required: true
        },
        rootPath: {
          type: String,
          required: true
        },
        image: {
          type: String,
          required: true
        }
      },
      data: function data() {
        return ModalStore.store;
      },

      watch: {
        activeTab: function activeTab() {
          if (this.activeTab === 'all') {
            ModalStore.purgeUnselectedIssues();
          }
        }
      },
      computed: {
        loopIssues: function loopIssues() {
          if (this.activeTab === 'all') {
            return this.issues;
          }

          return this.selectedIssues;
        },
        groupedIssues: function groupedIssues() {
          var _this = this;

          var groups = [];
          this.loopIssues.forEach(function (issue, i) {
            var index = i % _this.columns;

            if (!groups[index]) {
              groups.push([]);
            }

            groups[index].push(issue);
          });

          return groups;
        }
      },
      methods: {
        scrollHandler: function scrollHandler() {
          var currentPage = Math.floor(this.issues.length / this.perPage);

          if (this.scrollTop() > this.scrollHeight() - 100 && !this.loadingNewPage && currentPage === this.page) {
            this.loadingNewPage = true;
            this.page += 1;
          }
        },
        toggleIssue: function toggleIssue(e, issue) {
          if (e.target.tagName !== 'A') {
            ModalStore.toggleIssue(issue);
          }
        },
        listHeight: function listHeight() {
          return this.$refs.list.getBoundingClientRect().height;
        },
        scrollHeight: function scrollHeight() {
          return this.$refs.list.scrollHeight;
        },
        scrollTop: function scrollTop() {
          return this.$refs.list.scrollTop + this.listHeight();
        },
        showIssue: function showIssue(issue) {
          if (this.activeTab === 'all') return true;

          var index = ModalStore.selectedIssueIndex(issue);

          return index !== -1;
        },
        setColumnCount: function setColumnCount() {
          var breakpoint = bp.getBreakpointSize();

          if (breakpoint === 'lg' || breakpoint === 'md') {
            this.columns = 3;
          } else if (breakpoint === 'sm') {
            this.columns = 2;
          } else {
            this.columns = 1;
          }
        }
      },
      mounted: function mounted() {
        this.scrollHandlerWrapper = this.scrollHandler.bind(this);
        this.setColumnCountWrapper = this.setColumnCount.bind(this);
        this.setColumnCount();

        this.$refs.list.addEventListener('scroll', this.scrollHandlerWrapper);
        window.addEventListener('resize', this.setColumnCountWrapper);
      },
      beforeDestroy: function beforeDestroy() {
        this.$refs.list.removeEventListener('scroll', this.scrollHandlerWrapper);
        window.removeEventListener('resize', this.setColumnCountWrapper);
      },

      components: {
        'issue-card-inner': gl.issueBoards.IssueCardInner
      },
      template: '\n      <section\n        class="add-issues-list add-issues-list-columns"\n        ref="list">\n        <div\n          class="empty-state add-issues-empty-state-filter text-center"\n          v-if="issuesCount > 0 && issues.length === 0">\n          <div\n            class="svg-content"\n            v-html="image">\n          </div>\n          <div class="text-content">\n            <h4>\n              There are no issues to show.\n            </h4>\n          </div>\n        </div>\n        <div\n          v-for="group in groupedIssues"\n          class="add-issues-list-column">\n          <div\n            v-for="issue in group"\n            v-if="showIssue(issue)"\n            class="card-parent">\n            <div\n              class="card"\n              :class="{ \'is-active\': issue.selected }"\n              @click="toggleIssue($event, issue)">\n              <issue-card-inner\n                :issue="issue"\n                :issue-link-base="issueLinkBase"\n                :root-path="rootPath">\n              </issue-card-inner>\n              <span\n                :aria-label="\'Issue #\' + issue.id + \' selected\'"\n                aria-checked="true"\n                v-if="issue.selected"\n                class="issue-card-selected text-center">\n                <i class="fa fa-check"></i>\n              </span>\n            </div>\n          </div>\n        </div>\n      </section>\n    '
    });
  })();
}).call(window);

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Vue */
  (function () {
    var ModalStore = gl.issueBoards.ModalStore;

    gl.issueBoards.ModalFooterListsDropdown = Vue.extend({
      data: function data() {
        return {
          modal: ModalStore.store,
          state: gl.issueBoards.BoardsStore.state
        };
      },

      computed: {
        selected: function selected() {
          return this.modal.selectedList || this.state.lists[0];
        }
      },
      destroyed: function destroyed() {
        this.modal.selectedList = null;
      },

      template: "\n      <div class=\"dropdown inline\">\n        <button\n          class=\"dropdown-menu-toggle\"\n          type=\"button\"\n          data-toggle=\"dropdown\"\n          aria-expanded=\"false\">\n          <span\n            class=\"dropdown-label-box\"\n            :style=\"{ backgroundColor: selected.label.color }\">\n          </span>\n          {{ selected.title }}\n          <i class=\"fa fa-chevron-down\"></i>\n        </button>\n        <div class=\"dropdown-menu dropdown-menu-selectable dropdown-menu-drop-up\">\n          <ul>\n            <li\n              v-for=\"list in state.lists\"\n              v-if=\"list.type == 'label'\">\n              <a\n                href=\"#\"\n                role=\"button\"\n                :class=\"{ 'is-active': list.id == selected.id }\"\n                @click.prevent=\"modal.selectedList = list\">\n                <span\n                  class=\"dropdown-label-box\"\n                  :style=\"{ backgroundColor: list.label.color }\">\n                </span>\n                {{ list.title }}\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n    "
    });
  })();
}).call(window);

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Vue */
  (function () {
    var ModalStore = gl.issueBoards.ModalStore;

    gl.issueBoards.ModalTabs = Vue.extend({
      mixins: [gl.issueBoards.ModalMixins],
      data: function data() {
        return ModalStore.store;
      },

      computed: {
        selectedCount: function selectedCount() {
          return ModalStore.selectedCount();
        }
      },
      destroyed: function destroyed() {
        this.activeTab = 'all';
      },

      template: '\n      <div class="top-area prepend-top-10 append-bottom-10">\n        <ul class="nav-links issues-state-filters">\n          <li :class="{ \'active\': activeTab == \'all\' }">\n            <a\n              href="#"\n              role="button"\n              @click.prevent="changeTab(\'all\')">\n              All issues\n              <span class="badge">\n                {{ issuesCount }}\n              </span>\n            </a>\n          </li>\n          <li :class="{ \'active\': activeTab == \'selected\' }">\n            <a\n              href="#"\n              role="button"\n              @click.prevent="changeTab(\'selected\')">\n              Selected issues\n              <span class="badge">\n                {{ selectedCount }}\n              </span>\n            </a>\n          </li>\n        </ul>\n      </div>\n    '
    });
  })();
}).call(window);

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-new */
  /* global Vue */
  /* global Flash */
  (function () {
    var Store = gl.issueBoards.BoardsStore;

    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    gl.issueBoards.RemoveIssueBtn = Vue.extend({
      props: {
        issue: {
          type: Object,
          required: true
        },
        list: {
          type: Object,
          required: true
        }
      },
      methods: {
        removeIssue: function removeIssue() {
          var issue = this.issue;
          var lists = issue.getLists();
          var labelIds = lists.map(function (list) {
            return list.label.id;
          });

          // Post the remove data
          gl.boardService.bulkUpdate([issue.globalId], {
            remove_label_ids: labelIds
          }).catch(function () {
            new Flash('Failed to remove issue from board, please try again.', 'alert');

            lists.forEach(function (list) {
              list.addIssue(issue);
            });
          });

          // Remove from the frontend store
          lists.forEach(function (list) {
            list.removeIssue(issue);
          });

          Store.detail.issue = {};
        }
      },
      template: '\n      <div\n        class="block list"\n        v-if="list.type !== \'done\'">\n        <button\n          class="btn btn-default btn-block"\n          type="button"\n          @click="removeIssue">\n          Remove from board\n        </button>\n      </div>\n    '
    });
  })();
}).call(window);

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  module.exports = '<svg viewBox="0 0 28 22" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="m45.4978994 24.9892046c0 .4726429-.1654225.8743833-.4962726 1.2052333l-15.2426565 15.2426565c-.33085.33085-.7325904.4962725-1.2052333.4962725-.4726428 0-.8743833-.1654225-1.2052333-.4962725l-8.8265615-8.8265616c-.33085-.33085-.4962726-.7325904-.4962726-1.2052333 0-.4726428.1654226-.8743833.4962726-1.2052333l2.4104666-2.4104666c.33085-.33085.7325904-.4962725 1.2052333-.4962725s.8743833.1654225 1.2052333.4962725l5.2108616 5.2285857 11.6269566-11.6446806c.33085-.33085.7325905-.4962726 1.2052333-.4962726.4726429 0 .8743833.1654226 1.2052333.4962726l2.4104666 2.4104666c.3308501.33085.4962726.7325904.4962726 1.2052333z"/><mask id="b" fill="#fff" height="21.0561348" width="27.4722297" x="0" y="0"><use xlink:href="#a"/></mask></defs><use fill="none" mask="url(#b)" stroke="#1a97d5" stroke-width="2" transform="translate(-18 -20)" xlink:href="#a"/></svg>';
}).call(window);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable func-names, prefer-arrow-callback, no-unused-vars,
  no-param-reassign, no-plusplus */
  /* global Vue */

  Vue.http.interceptors.push(function (request, next) {
    Vue.activeResources = Vue.activeResources ? Vue.activeResources + 1 : 1;

    next(function (response) {
      if (typeof response.data === 'string') {
        response.data = JSON.parse(response.data);
      }

      Vue.activeResources--;
    });
  });

  Vue.http.interceptors.push(function (request, next) {
    // needed in order to not break the tests.
    if ($.rails) {
      request.headers['X-CSRF-Token'] = $.rails.csrfToken();
    }
    next();
  });
}).call(window);

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable one-var, quote-props, comma-dangle, space-before-function-paren, import/newline-after-import, no-multi-spaces, max-len */
  /* global Vue */
  /* global BoardService */

  function requireAll(context) {
    return context.keys().map(context);
  }

  window.Vue = __webpack_require__(0);
  window.Vue.use(__webpack_require__(2));
  window.Sortable = __webpack_require__(215);
  requireAll(__webpack_require__(161));
  requireAll(__webpack_require__(163));
  requireAll(__webpack_require__(162));
  requireAll(__webpack_require__(160));
  requireAll(__webpack_require__(159));
  __webpack_require__(185);
  __webpack_require__(186);
  __webpack_require__(189);
  __webpack_require__(188);
  var backlogHelp = __webpack_require__(187);
  __webpack_require__(3);

  $(function () {
    var $boardApp = document.getElementById('board-app');
    var Store = gl.issueBoards.BoardsStore;
    var ModalStore = gl.issueBoards.ModalStore;

    window.gl = window.gl || {};

    if (gl.IssueBoardsApp) {
      gl.IssueBoardsApp.$destroy(true);
    }

    Store.create();

    gl.IssueBoardsApp = new Vue({
      el: $boardApp,
      components: {
        'board': gl.issueBoards.Board,
        'board-sidebar': gl.issueBoards.BoardSidebar,
        'board-add-issues-modal': gl.issueBoards.IssuesModal,
        backlogHelp: backlogHelp
      },
      data: {
        state: Store.state,
        loading: true,
        endpoint: $boardApp.dataset.endpoint,
        boardId: $boardApp.dataset.boardId,
        disabled: $boardApp.dataset.disabled === 'true',
        issueLinkBase: $boardApp.dataset.issueLinkBase,
        rootPath: $boardApp.dataset.rootPath,
        bulkUpdatePath: $boardApp.dataset.bulkUpdatePath,
        detailIssue: Store.detail
      },
      computed: {
        detailIssueVisible: function detailIssueVisible() {
          return Object.keys(this.detailIssue.issue).length;
        },
        hideHelp: function hideHelp() {
          if (this.loading) return false;

          return !this.state.helpHidden;
        }
      },
      created: function created() {
        gl.boardService = new BoardService(this.endpoint, this.bulkUpdatePath, this.boardId);
      },
      mounted: function mounted() {
        var _this = this;

        Store.disabled = this.disabled;
        gl.boardService.all().then(function (resp) {
          resp.json().forEach(function (board) {
            var list = Store.addList(board);

            if (list.type === 'done') {
              list.position = Infinity;
            }
          });

          _this.state.lists = _.sortBy(_this.state.lists, 'position');

          Store.addBlankState();
          _this.loading = false;
        });
      }
    });

    gl.IssueBoardsSearch = new Vue({
      el: document.getElementById('js-boards-search'),
      data: {
        filters: Store.state.filters
      },
      mounted: function mounted() {
        gl.issueBoards.newListDropdownInit();
      }
    });

    gl.IssueBoardsModalAddBtn = new Vue({
      mixins: [gl.issueBoards.ModalMixins],
      el: document.getElementById('js-add-issues-btn'),
      data: {
        modal: ModalStore.store,
        store: Store.state
      },
      watch: {
        disabled: function disabled() {
          this.updateTooltip();
        }
      },
      computed: {
        disabled: function disabled() {
          return !this.store.lists.filter(function (list) {
            return list.type !== 'blank' && list.type !== 'done';
          }).length;
        },
        tooltipTitle: function tooltipTitle() {
          if (this.disabled) {
            return 'Please add a list to your board first';
          }

          return '';
        }
      },
      methods: {
        updateTooltip: function updateTooltip() {
          var _this2 = this;

          var $tooltip = $(this.$el);

          this.$nextTick(function () {
            if (_this2.disabled) {
              $tooltip.tooltip();
            } else {
              $tooltip.tooltip('destroy');
            }
          });
        },
        openModal: function openModal() {
          if (!this.disabled) {
            this.toggleModal(true);
          }
        }
      },
      mounted: function mounted() {
        this.updateTooltip();
      },

      template: '\n      <button\n        class="btn btn-create pull-right prepend-left-10"\n        type="button"\n        data-placement="bottom"\n        :class="{ \'disabled\': disabled }"\n        :title="tooltipTitle"\n        :aria-disabled="disabled"\n        @click="openModal">\n        Add issues\n      </button>\n    '
    });
  });
}).call(window);

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Vue */
  /* global dateFormat */

  Vue.filter('due-date', function (value) {
    var date = new Date(value);
    return dateFormat(date, 'mmm d, yyyy', true);
  });
}).call(window);

/***/ }),

/***/ 66:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* global Cookies */
  (function () {
    var Store = gl.issueBoards.BoardsStore;
    var ModalStore = gl.issueBoards.ModalStore;

    gl.issueBoards.ModalMixins = {
      methods: {
        toggleModal: function toggleModal(_toggleModal) {
          var setCookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

          if (setCookie) {
            Cookies.set('boards_backlog_help_hidden', true);
            Store.state.helpHidden = true;
          }

          ModalStore.store.showAddIssuesModal = _toggleModal;
        },
        changeTab: function changeTab(tab) {
          ModalStore.store.activeTab = tab;
        }
      }
    };
  })();
}).call(window);

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-unused-vars, no-mixed-operators, comma-dangle */
  /* global DocumentTouch */

  (function (w) {
    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    gl.issueBoards.onStart = function () {
      $('.has-tooltip').tooltip('hide').tooltip('disable');
      document.body.classList.add('is-dragging');
    };

    gl.issueBoards.onEnd = function () {
      $('.has-tooltip').tooltip('enable');
      document.body.classList.remove('is-dragging');
    };

    gl.issueBoards.touchEnabled = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;

    gl.issueBoards.getBoardSortableDefaultOptions = function (obj) {
      var defaultSortOptions = {
        animation: 200,
        forceFallback: true,
        fallbackClass: 'is-dragging',
        fallbackOnBody: true,
        ghostClass: 'is-ghost',
        filter: '.board-delete, .btn',
        delay: gl.issueBoards.touchEnabled ? 100 : 0,
        scrollSensitivity: gl.issueBoards.touchEnabled ? 60 : 100,
        scrollSpeed: 20,
        onStart: gl.issueBoards.onStart,
        onEnd: gl.issueBoards.onEnd
      };

      Object.keys(obj).forEach(function (key) {
        defaultSortOptions[key] = obj[key];
      });
      return defaultSortOptions;
    };
  })(window);
}).call(window);

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-unused-vars, space-before-function-paren, arrow-body-style, arrow-parens, comma-dangle, max-len */
  /* global Vue */
  /* global ListLabel */
  /* global ListMilestone */
  /* global ListUser */

  var ListIssue = function () {
    function ListIssue(obj) {
      var _this = this;

      _classCallCheck(this, ListIssue);

      this.globalId = obj.id;
      this.id = obj.iid;
      this.title = obj.title;
      this.confidential = obj.confidential;
      this.dueDate = obj.due_date;
      this.subscribed = obj.subscribed;
      this.labels = [];
      this.selected = false;
      this.assignee = false;

      if (obj.assignee) {
        this.assignee = new ListUser(obj.assignee);
      }

      if (obj.milestone) {
        this.milestone = new ListMilestone(obj.milestone);
      }

      obj.labels.forEach(function (label) {
        _this.labels.push(new ListLabel(label));
      });

      this.priority = this.labels.reduce(function (max, label) {
        return label.priority < max ? label.priority : max;
      }, Infinity);
    }

    _createClass(ListIssue, [{
      key: 'addLabel',
      value: function addLabel(label) {
        if (!this.findLabel(label)) {
          this.labels.push(new ListLabel(label));
        }
      }
    }, {
      key: 'findLabel',
      value: function findLabel(_findLabel) {
        return this.labels.filter(function (label) {
          return label.title === _findLabel.title;
        })[0];
      }
    }, {
      key: 'removeLabel',
      value: function removeLabel(_removeLabel) {
        if (_removeLabel) {
          this.labels = this.labels.filter(function (label) {
            return _removeLabel.title !== label.title;
          });
        }
      }
    }, {
      key: 'removeLabels',
      value: function removeLabels(labels) {
        labels.forEach(this.removeLabel.bind(this));
      }
    }, {
      key: 'getLists',
      value: function getLists() {
        var _this2 = this;

        return gl.issueBoards.BoardsStore.state.lists.filter(function (list) {
          return list.findIssue(_this2.id);
        });
      }
    }, {
      key: 'update',
      value: function update(url) {
        var data = {
          issue: {
            milestone_id: this.milestone ? this.milestone.id : null,
            due_date: this.dueDate,
            assignee_id: this.assignee ? this.assignee.id : null,
            label_ids: this.labels.map(function (label) {
              return label.id;
            })
          }
        };

        if (!data.issue.label_ids.length) {
          data.issue.label_ids = [''];
        }

        return Vue.http.patch(url, data);
      }
    }]);

    return ListIssue;
  }();

  window.ListIssue = ListIssue;
}).call(window);

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-unused-vars, space-before-function-paren */

  var ListLabel = function ListLabel(obj) {
    _classCallCheck(this, ListLabel);

    this.id = obj.id;
    this.title = obj.title;
    this.color = obj.color;
    this.textColor = obj.text_color;
    this.description = obj.description;
    this.priority = obj.priority !== null ? obj.priority : Infinity;
  };

  window.ListLabel = ListLabel;
}).call(window);

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable space-before-function-paren, no-underscore-dangle, class-methods-use-this, consistent-return, no-shadow, no-param-reassign, max-len, no-unused-vars */
  /* global ListIssue */
  /* global ListLabel */

  var List = function () {
    function List(obj) {
      _classCallCheck(this, List);

      this.id = obj.id;
      this._uid = this.guid();
      this.position = obj.position;
      this.title = obj.title;
      this.type = obj.list_type;
      this.preset = ['done', 'blank'].indexOf(this.type) > -1;
      this.filters = gl.issueBoards.BoardsStore.state.filters;
      this.page = 1;
      this.loading = true;
      this.loadingMore = false;
      this.issues = [];
      this.issuesSize = 0;

      if (obj.label) {
        this.label = new ListLabel(obj.label);
      }

      if (this.type !== 'blank' && this.id) {
        this.getIssues();
      }
    }

    _createClass(List, [{
      key: 'guid',
      value: function guid() {
        var s4 = function s4() {
          return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        };
        return '' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }
    }, {
      key: 'save',
      value: function save() {
        var _this = this;

        return gl.boardService.createList(this.label.id).then(function (resp) {
          var data = resp.json();

          _this.id = data.id;
          _this.type = data.list_type;
          _this.position = data.position;

          return _this.getIssues();
        });
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        var index = gl.issueBoards.BoardsStore.state.lists.indexOf(this);
        gl.issueBoards.BoardsStore.state.lists.splice(index, 1);
        gl.issueBoards.BoardsStore.updateNewListDropdown(this.id);

        gl.boardService.destroyList(this.id);
      }
    }, {
      key: 'update',
      value: function update() {
        gl.boardService.updateList(this.id, this.position);
      }
    }, {
      key: 'nextPage',
      value: function nextPage() {
        if (this.issuesSize > this.issues.length) {
          this.page += 1;

          return this.getIssues(false);
        }
      }
    }, {
      key: 'getIssues',
      value: function getIssues() {
        var _this2 = this;

        var emptyIssues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        var filters = this.filters;
        var data = { page: this.page };

        Object.keys(filters).forEach(function (key) {
          data[key] = filters[key];
        });

        if (this.label) {
          data.label_name = data.label_name.filter(function (label) {
            return label !== _this2.label.title;
          });
        }

        if (emptyIssues) {
          this.loading = true;
        }

        return gl.boardService.getIssuesForList(this.id, data).then(function (resp) {
          var data = resp.json();
          _this2.loading = false;
          _this2.issuesSize = data.size;

          if (emptyIssues) {
            _this2.issues = [];
          }

          _this2.createIssues(data.issues);
        });
      }
    }, {
      key: 'newIssue',
      value: function newIssue(issue) {
        this.addIssue(issue);
        this.issuesSize += 1;

        return gl.boardService.newIssue(this.id, issue).then(function (resp) {
          var data = resp.json();
          issue.id = data.iid;
        });
      }
    }, {
      key: 'createIssues',
      value: function createIssues(data) {
        var _this3 = this;

        data.forEach(function (issueObj) {
          _this3.addIssue(new ListIssue(issueObj));
        });
      }
    }, {
      key: 'addIssue',
      value: function addIssue(issue, listFrom, newIndex) {
        if (!this.findIssue(issue.id)) {
          if (newIndex !== undefined) {
            this.issues.splice(newIndex, 0, issue);
          } else {
            this.issues.push(issue);
          }

          if (this.label) {
            issue.addLabel(this.label);
          }

          if (listFrom) {
            this.issuesSize += 1;
            gl.boardService.moveIssue(issue.id, listFrom.id, this.id).then(function () {
              listFrom.getIssues(false);
            });
          }
        }
      }
    }, {
      key: 'findIssue',
      value: function findIssue(id) {
        return this.issues.filter(function (issue) {
          return issue.id === id;
        })[0];
      }
    }, {
      key: 'removeIssue',
      value: function removeIssue(_removeIssue) {
        var _this4 = this;

        this.issues = this.issues.filter(function (issue) {
          var matchesRemove = _removeIssue.id === issue.id;

          if (matchesRemove) {
            _this4.issuesSize -= 1;
            issue.removeLabel(_this4.label);
          }

          return !matchesRemove;
        });
      }
    }]);

    return List;
  }();

  window.List = List;
}).call(window);

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-unused-vars */

  var ListMilestone = function ListMilestone(obj) {
    _classCallCheck(this, ListMilestone);

    this.id = obj.id;
    this.title = obj.title;
  };

  window.ListMilestone = ListMilestone;
}).call(window);

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable no-unused-vars */

  var ListUser = function ListUser(user) {
    _classCallCheck(this, ListUser);

    this.id = user.id;
    this.name = user.name;
    this.username = user.username;
    this.avatar = user.avatar_url;
  };

  window.ListUser = ListUser;
}).call(window);

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable space-before-function-paren, comma-dangle, no-param-reassign, camelcase, max-len, no-unused-vars */
  /* global Vue */

  var BoardService = function () {
    function BoardService(root, bulkUpdatePath, boardId) {
      _classCallCheck(this, BoardService);

      this.boards = Vue.resource(root + '{/id}.json', {}, {
        issues: {
          method: 'GET',
          url: root + '/' + boardId + '/issues.json'
        }
      });
      this.lists = Vue.resource(root + '/' + boardId + '/lists{/id}', {}, {
        generate: {
          method: 'POST',
          url: root + '/' + boardId + '/lists/generate.json'
        }
      });
      this.issue = Vue.resource(root + '/' + boardId + '/issues{/id}', {});
      this.issues = Vue.resource(root + '/' + boardId + '/lists{/id}/issues', {}, {
        bulkUpdate: {
          method: 'POST',
          url: bulkUpdatePath
        }
      });

      Vue.http.interceptors.push(function (request, next) {
        request.headers['X-CSRF-Token'] = $.rails.csrfToken();
        next();
      });
    }

    _createClass(BoardService, [{
      key: 'all',
      value: function all() {
        return this.lists.get();
      }
    }, {
      key: 'generateDefaultLists',
      value: function generateDefaultLists() {
        return this.lists.generate({});
      }
    }, {
      key: 'createList',
      value: function createList(label_id) {
        return this.lists.save({}, {
          list: {
            label_id: label_id
          }
        });
      }
    }, {
      key: 'updateList',
      value: function updateList(id, position) {
        return this.lists.update({ id: id }, {
          list: {
            position: position
          }
        });
      }
    }, {
      key: 'destroyList',
      value: function destroyList(id) {
        return this.lists.delete({ id: id });
      }
    }, {
      key: 'getIssuesForList',
      value: function getIssuesForList(id) {
        var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var data = { id: id };
        Object.keys(filter).forEach(function (key) {
          data[key] = filter[key];
        });

        return this.issues.get(data);
      }
    }, {
      key: 'moveIssue',
      value: function moveIssue(id, from_list_id, to_list_id) {
        return this.issue.update({ id: id }, {
          from_list_id: from_list_id,
          to_list_id: to_list_id
        });
      }
    }, {
      key: 'newIssue',
      value: function newIssue(id, issue) {
        return this.issues.save({ id: id }, {
          issue: issue
        });
      }
    }, {
      key: 'getBacklog',
      value: function getBacklog(data) {
        return this.boards.issues(data);
      }
    }, {
      key: 'bulkUpdate',
      value: function bulkUpdate(issueIds) {
        var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var data = {
          update: Object.assign(extraData, {
            issuable_ids: issueIds.join(',')
          })
        };

        return this.issues.bulkUpdate(data);
      }
    }]);

    return BoardService;
  }();

  window.BoardService = BoardService;
}).call(window);

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function () {

  /* eslint-disable comma-dangle, space-before-function-paren, one-var, no-shadow, dot-notation, max-len */
  /* global Cookies */
  /* global List */

  (function () {
    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    gl.issueBoards.BoardsStore = {
      disabled: false,
      state: {},
      detail: {
        issue: {}
      },
      moving: {
        issue: {},
        list: {}
      },
      create: function create() {
        this.state.lists = [];
        this.state.filters = {
          author_id: gl.utils.getParameterValues('author_id')[0],
          assignee_id: gl.utils.getParameterValues('assignee_id')[0],
          milestone_title: gl.utils.getParameterValues('milestone_title')[0],
          label_name: gl.utils.getParameterValues('label_name[]'),
          search: ''
        };
        this.state.helpHidden = Cookies.get('boards_backlog_help_hidden') === 'true';
      },
      addList: function addList(listObj) {
        var list = new List(listObj);
        this.state.lists.push(list);

        return list;
      },
      new: function _new(listObj) {
        var _this = this;

        var list = this.addList(listObj);

        list.save().then(function () {
          _this.state.lists = _.sortBy(_this.state.lists, 'position');
        });
        this.removeBlankState();
      },
      updateNewListDropdown: function updateNewListDropdown(listId) {
        $('.js-board-list-' + listId).removeClass('is-active');
      },
      shouldAddBlankState: function shouldAddBlankState() {
        // Decide whether to add the blank state
        return !this.state.lists.filter(function (list) {
          return list.type !== 'done';
        })[0];
      },
      addBlankState: function addBlankState() {
        if (!this.shouldAddBlankState() || this.welcomeIsHidden() || this.disabled) return;

        this.addList({
          id: 'blank',
          list_type: 'blank',
          title: 'Welcome to your Issue Board!',
          position: 0
        });

        this.state.lists = _.sortBy(this.state.lists, 'position');
      },
      removeBlankState: function removeBlankState() {
        this.removeList('blank');

        Cookies.set('issue_board_welcome_hidden', 'true', {
          expires: 365 * 10,
          path: ''
        });
      },
      welcomeIsHidden: function welcomeIsHidden() {
        return Cookies.get('issue_board_welcome_hidden') === 'true';
      },
      removeList: function removeList(id) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blank';

        var list = this.findList('id', id, type);

        if (!list) return;

        this.state.lists = this.state.lists.filter(function (list) {
          return list.id !== id;
        });
      },
      moveList: function moveList(listFrom, orderLists) {
        var _this2 = this;

        orderLists.forEach(function (id, i) {
          var list = _this2.findList('id', parseInt(id, 10));

          list.position = i;
        });
        listFrom.update();
      },
      moveIssueToList: function moveIssueToList(listFrom, listTo, issue, newIndex) {
        var issueTo = listTo.findIssue(issue.id);
        var issueLists = issue.getLists();
        var listLabels = issueLists.map(function (listIssue) {
          return listIssue.label;
        });

        // Add to new lists issues if it doesn't already exist
        if (!issueTo) {
          listTo.addIssue(issue, listFrom, newIndex);
        }

        if (listTo.type === 'done') {
          issueLists.forEach(function (list) {
            list.removeIssue(issue);
          });
          issue.removeLabels(listLabels);
        } else {
          listFrom.removeIssue(issue);
        }
      },
      findList: function findList(key, val) {
        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';

        return this.state.lists.filter(function (list) {
          var byType = type ? list['type'] === type : true;

          return list[key] === val && byType;
        })[0];
      },
      updateFiltersUrl: function updateFiltersUrl() {
        history.pushState(null, null, '?' + $.param(this.state.filters));
      }
    };
  })();
}).call(window);

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*** IMPORTS FROM imports-loader ***/
(function () {

  (function () {
    window.gl = window.gl || {};
    window.gl.issueBoards = window.gl.issueBoards || {};

    var ModalStore = function () {
      function ModalStore() {
        _classCallCheck(this, ModalStore);

        this.store = {
          columns: 3,
          issues: [],
          issuesCount: false,
          selectedIssues: [],
          showAddIssuesModal: false,
          activeTab: 'all',
          selectedList: null,
          searchTerm: '',
          loading: false,
          loadingNewPage: false,
          page: 1,
          perPage: 50
        };

        this.setDefaultFilter();
      }

      _createClass(ModalStore, [{
        key: 'setDefaultFilter',
        value: function setDefaultFilter() {
          this.store.filter = {
            author_id: '',
            assignee_id: '',
            milestone_title: '',
            label_name: []
          };
        }
      }, {
        key: 'selectedCount',
        value: function selectedCount() {
          return this.getSelectedIssues().length;
        }
      }, {
        key: 'toggleIssue',
        value: function toggleIssue(issueObj) {
          var issue = issueObj;
          var selected = issue.selected;

          issue.selected = !selected;

          if (!selected) {
            this.addSelectedIssue(issue);
          } else {
            this.removeSelectedIssue(issue);
          }
        }
      }, {
        key: 'toggleAll',
        value: function toggleAll() {
          var _this = this;

          var select = this.selectedCount() !== this.store.issues.length;

          this.store.issues.forEach(function (issue) {
            var issueUpdate = issue;

            if (issueUpdate.selected !== select) {
              issueUpdate.selected = select;

              if (select) {
                _this.addSelectedIssue(issue);
              } else {
                _this.removeSelectedIssue(issue);
              }
            }
          });
        }
      }, {
        key: 'getSelectedIssues',
        value: function getSelectedIssues() {
          return this.store.selectedIssues.filter(function (issue) {
            return issue.selected;
          });
        }
      }, {
        key: 'addSelectedIssue',
        value: function addSelectedIssue(issue) {
          var index = this.selectedIssueIndex(issue);

          if (index === -1) {
            this.store.selectedIssues.push(issue);
          }
        }
      }, {
        key: 'removeSelectedIssue',
        value: function removeSelectedIssue(issue) {
          var forcePurge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

          if (this.store.activeTab === 'all' || forcePurge) {
            this.store.selectedIssues = this.store.selectedIssues.filter(function (fIssue) {
              return fIssue.id !== issue.id;
            });
          }
        }
      }, {
        key: 'purgeUnselectedIssues',
        value: function purgeUnselectedIssues() {
          var _this2 = this;

          this.store.selectedIssues.forEach(function (issue) {
            if (!issue.selected) {
              _this2.removeSelectedIssue(issue, true);
            }
          });
        }
      }, {
        key: 'selectedIssueIndex',
        value: function selectedIssueIndex(issue) {
          return this.store.selectedIssues.indexOf(issue);
        }
      }, {
        key: 'findSelectedIssue',
        value: function findSelectedIssue(issue) {
          return this.store.selectedIssues.filter(function (filteredIssue) {
            return filteredIssue.id === issue.id;
          })[0];
        }
      }]);

      return ModalStore;
    }();

    gl.issueBoards.ModalStore = new ModalStore();
  })();
}).call(window);

/***/ })

/******/ });


// WEBPACK FOOTER //
// boards-3c2409b51385b0e37693-v2.js